<template>
  <div id="settingContainer" class="page-container">
    <div class="page-content">
      <div v-if="setingChanged" class="warning-popup">
        <div class="body flex-center" style="width: 430px">
          <div class="fs-500 fc-FFFFFF fs-14">
            You've made changes to your settings
          </div>
          <div @click="undoSaveSetting" class="cursor-pointer ml-auto undo-bottom flex-mid">
            Undo
          </div>
          <div @click="saveChanges" class="cursor-pointer save-bottom flex-mid">
            Save Changes
          </div>
        </div>
      </div>
      <div class="flex-row-center mt-16">
        <img @click.prevent="refresh" src="../assets/images/navbar/ic_settings.webp" class="icon-pages" />
        <span class="page-title">Settings</span>
        <div class="page-des page-des-line-button">
          Configure general settings and customize experiences
        </div>
        <div class="button-title">
          <el-button class="btnAddSettings" type="primary" @click="saveChanges">Save Changes</el-button>
        </div>
      </div>

      <div class="div-page-content flex-column mt-32 relative">
        <el-tabs class="styleTab" v-model="activeTab">
          <el-tab-pane name="general">
            <span slot="label" class="title-bar">General Settings</span>
            <!-- General Settings Tab -->
            <el-form class="margin-subpages">
              <div id="generalSettings">
                <span class="sub-title">GENERAL SETTINGS</span>
                <div class="line-style mt-24" />
                <div style="margin-top: 32px; margin-right: 100px">
                  <el-form-item style="margin-bottom: 16px">
                    <span slot="label" class="inputLabelStyle">Company Name</span>
                    <el-input disabled class="inputReportStyle" 
                    v-model="user.company_name" :class="[ blurMode ?  'blurelement': '' ]"></el-input>
                  </el-form-item>
                </div>
                <div style="margin-top: 32px; margin-right: 100px">
                  <div>
                    <div class="header-text">Pulse & Report Schedule</div>
                    <span class="description-text">Set the time that questions and reports are delivered to your teams</span>
                  </div>
                </div>
                <div id="formReport" class="mx-2 mt-32 grid-2-50">
                  <div>
                    <el-form-item style="margin-bottom: 16px" prop="date1" v-if="settingData.gen_question == 'Y'">
                      <span slot="label" class="inputLabelStyle">Daily Pulse</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 15:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time" v-model="settingData.starttime"
                        placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Mon - Fri</span>
                    </el-form-item>

                    <el-form-item style="margin-bottom: 16px" prop="date3" v-if="settingData.report_dailyboss == 'Y'">
                      <span slot="label" class="inputLabelStyle">Daily Insights</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_dailyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Tue - Sat</span>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item prop="date4" v-if="settingData.report_weeklyboss == 'Y'">
                      <span slot="label" class="inputLabelStyle">Weekly Insights</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 14:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_weeklyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">Monday</span>
                    </el-form-item>
                    <el-form-item prop="date4" v-if="settingData.report_monthly_insights == 'Y'">
                      <span slot="label" class="inputLabelStyle">Monthly Insights</span>
                      <el-time-picker :picker-options="{ selectableRange: '05:00:00 - 16:00:00' }" format="h:mm A"
                        value-format="h:mm A" class="inputReportStyle" type="fixed-time"
                        v-model="settingData.report_monthlyboss_time" placement="bottom-start"></el-time-picker>
                      <span style="
                          pointer-events: none;
                          font-size: 18px;
                          color: #b5b5b5;
                          position: absolute;
                          left: 207px;
                          top: 6px;
                        ">1st of Mo</span>
                    </el-form-item>
                  </div>
                </div>

                <div style="margin-top: 32px; margin-right: 100px">
                  <div>
                    <div class="header-text">Company Holidays</div>
                    <span class="description-text">Daily pulse questions are paused on upcoming company
                      holidays</span>
                  </div>
                  <div v-if="settingData['holiday_tag'] &&
                    settingData['holiday_tag'].length > 0
                    " style="display: flex; flex-wrap: wrap; gap: 8px;" class="pt-12">
                    <div class="preset-date-tag" v-for="(item, index) in settingData['holiday_tag']" :key="item">
                      <i class="el-icon-date date-icon"></i>
                      <span>{{ item }}</span>
                      <i @click="removeTag(index)" class="el-icon-close"></i>
                    </div>
                  </div>
                  <div v-bind:style="'position: relative; padding-top: ' +
                    getPaddingStyle(settingData['holiday_tag'])
                    " v-if="settingData['holiday_val']">
                    <el-button style="width:200px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showDatepickerHoliday">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                        <span>Add Holidays</span>
                      </div>
                    </el-button>
                    <el-date-picker :clearable="false" :editable="false" @change="confirmHolidayDatepicker"
                      class="dialogInputDatepicker" ref="datepicker_holiday" type="dates" v-model="settingData['holiday_val']"
                      placement="bottom-start" style="position: absolute; top: 0; left: 0; opacity: 0; pointer-events: none;"></el-date-picker>
                  </div>

                  <!-- Personal Holiday Presets Section -->
                  <div style="margin-top: 32px;">
                    <div>
                      <div class="header-text">Personal Holiday Presets</div>
                      <span class="description-text">Create team or member-specific holiday schedules to pause daily pulse questions on individual days off</span>
                    </div>
                    <div style="margin-top: 16px;">
                      <el-button style="width:200px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showModal_holiday_presets=true">
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                          <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                          <span>Set Personal Holiday</span>
                        </div>
                      </el-button>
                      <div style="margin-top: 8px; font-size: 14px;">{{ presetlistAll?presetlistAll.length:0 }} Holiday Presets Active</div>
                    </div>
                  </div>
                </div>



                <div class="header-text mt-52">
                  <div class="header-text">Activity Feed Names</div>
                  <div class="description-text">
                    When enabled, Activity Feed rows show nicknames when available. When disabled, rows use first names instead.
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="activity_feed_use_nickname"
                          v-model="settingData.activity_feed_use_nickname" />
                        <label for="activity_feed_use_nickname" :class="`${settingData.activity_feed_use_nickname
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.activity_feed_use_nickname" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Use nicknames in Activity Feed</span>
                  </div>
                </div>

                <div class="header-text mt-52">
                  <div class="header-text">Happily Assistance</div>
                  <div class="description-text">
                    Allow the Happily team access to your console to assist with
                    account management and recommendations.
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="happilyAssistAccess_checked"
                          v-model="settingData.happilyAssistAccess_checked" />
                        <label for="happilyAssistAccess_checked" :class="`${settingData.happilyAssistAccess_checked
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.happilyAssistAccess_checked" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Happily Assist Access</span>
                  </div>
                </div>
                <div class="line-style mt-32" />
                <div class="header-text mt-24">Demo Mode</div>
                <div class="description-text">
                  Usernames, emails, teams and profile images associated with existing members 
                  are blurred across all pages when demo mode is turned on. Use with discretion
                  - some elements may not be completely censored.
                </div>
                <div class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="demoMode_checked"
                        :checked="blurMode" @change="toggleDemoMode" />
                      <label for="demoMode_checked" :class="blurMode ? 'power-on' : 'power-off'">
                        <div class="switch-body flex-mid">
                          <div v-if="blurMode" class="mr-auto ml-14 mt-2">ON</div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Enable Demo Mode</span>
                </div>
                <div class="mt-24 fc-4A4A4A fs-14">Windows:
                  <span class="key">Ctrl</span> + <span class="key">Alt</span> + <span class="key">D</span> or
                  <span class="key">⊞</span> + <span class="key">Alt</span> + <span class="key">D</span>
                </div>
                <div class="mt-24 fc-4A4A4A fs-14">Mac: 
                  <span class="key">⌃</span> + <span class="key">⌥</span> + <span class="key">D</span> or
                  <span class="key">⌘</span> + <span class="key">⌥</span> + <span class="key">D</span>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="performance">
            <span slot="label" class="title-bar">Performance Reviews</span>
            <!-- Performance Reviews Tab -->
            <el-form class="margin-subpages">
              <div style="margin-top: 32px;">
                <span class="sub-title">PERFORMANCE REVIEWS</span>
                <div class="line-style mt-24" />

                <!-- Enable Performance Boosts Toggle -->
                <div>
                  <div class="header-text mt-32">Enable Performance Boosts</div>
                  <span class="description-text">Performance Boosts allow managers to provide structured feedback and recognition through gem awards. This data contributes to employee Impact Ratings.</span>
                </div>

                <div v-if="settingData.performance_review" class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="performance_boosts_enabled"
                        v-model="settingData.performance_review.enabled" />
                      <label for="performance_boosts_enabled" :class="`${settingData.performance_review.enabled
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.enabled" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Performance Boosts</span>
                </div>

                <div v-if="settingData.performance_review" class="description-text mt-8" style="font-style: italic; color: #908D95;">
                  {{ settingData.performance_review.enabled ?
                    'Managers can award gems during performance reviews. These awards contribute to Impact Ratings.' :
                    'Performance Boosts are disabled. Team members will not receive gems from managers, and Impact Ratings will not include performance review data.' }}
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled">
                  <!-- <div class="line-style mt-32" /> -->
                  <div>
                    <div class="header-text mt-32">Performance Boost Notice</div>
                    <span class="description-text">Set the optimal review schedule for managers to provide performance
                      reviews</span>
                  </div>
                </div>
                <div v-if="settingData.performance_review && settingData.performance_review.enabled" id="formReport" class="mx-2 mt-32 grid-2-50">
                  <div>
                    <el-form-item style="margin-bottom: 16px">
                        <span slot="label" class="inputLabelStyle">Pending after</span>
                        <el-select v-model="settingData.performance_review.pending" class="inputReportStyle" placeholder="Select duration" @change="pendingAfterChange">
                          <el-option v-for="month in [1, 2, 3]" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item style="margin-bottom: 16px">
                        <span slot="label" class="inputLabelStyle">Overdue after</span>
                        <el-select v-model="settingData.performance_review.overdue" class="inputReportStyle" placeholder="Select duration">
                          <el-option v-for="month in overdueMonths" :key="month" :label="`${month} ${month === 1 ? 'month' : 'months'}`" :value="month"></el-option>
                        </el-select>
                      </el-form-item>
                  </div>
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled" class="flex-center mt-18">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="ai_review_feedback"
                        v-model="settingData.performance_review.ai_review_feedback" />
                      <label for="ai_review_feedback" :class="`${settingData.performance_review.ai_review_feedback
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.ai_review_feedback" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">AI-Reviewed Feedback</span>
                </div>

                <div v-if="settingData.performance_review && settingData.performance_review.enabled" class="flex-center mt-18" :style="settingData.performance_review.pending != 1?'opacity: 0.5':''">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="reset_completed_monthly"
                        v-model="settingData.performance_review.reset_completed_monthly"
                        :disabled="settingData.performance_review.pending != 1"
                        />
                      <label for="reset_completed_monthly" :class="`${settingData.performance_review.reset_completed_monthly
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.performance_review.reset_completed_monthly" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Reset Monthly</span>
                </div>

              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="values">
            <span slot="label" class="title-bar">Skills & Values</span>
            <!-- Skills & Values Tab -->
            <el-form class="margin-subpages" @submit.native.prevent>
              <div style="margin-top: 32px;"></div>
              <span class="sub-title">SKILLS & VALUES</span>
              <div class="line-style mt-24" />
              
              <div class="flex">
                <div>
                  <div ref="recognition-values" class="header-text mt-24">
                    Recognition Values
                  </div>
                  <div class="description-text">
                    Peer and manager-driven recognition can be guided or forced to
                    align with specific company values, represented as hashtags in
                    the recognition interactions
                  </div>
                </div>
                <el-popover placement="bottom-end" width="200" trigger="click" class="mt-24 ml-auto"
                  v-model="popover.visibleRecognition" v-if="settingData.recognitionValue_checked && multiLang"
                  popper-class="language-selector-popover">
                  <div class="language-selector-content">
                    <div class="language-selector-header">
                      <i class="el-icon-s-flag"></i>
                      <span>Select Language</span>
                    </div>
                    <div v-for="val in language" :key="val.code" 
                         class="language-option" 
                         :class="{ 'active': popover.langRecognition === val.code.toUpperCase() }"
                         @click="setLanguage('recognition', val.code.toUpperCase())">
                      <div class="language-flag">
                        <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                          {{ getLanguageEmoji(val.code) }}
                        </div>
                      </div>
                      <span class="language-text">{{ val.text }}</span>
                      <i v-if="popover.langRecognition === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                    </div>
                  </div>
                  <div slot="reference" class="language-selector-button">
                    <div class="language-selector-content-btn">
                      <div class="language-flag-btn">
                        <div class="flag-icon-btn" :class="`flag-${getCurrentLanguageCode('recognition').toLowerCase()}`">
                          {{ getLanguageEmoji(getCurrentLanguageCode('recognition')) }}
                        </div>
                      </div>
                      <span class="language-text-btn">{{ popover.langRecognition }}</span>
                      <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': popover.visibleRecognition }"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="flex-center mt-18">
                <div class="switch mr-16">
                  <div class="can-toggle">
                    <input class="input" type="checkbox" id="recognitionValue_checked"
                      v-model="settingData.recognitionValue_checked" />
                    <label for="recognitionValue_checked" :class="`${settingData.recognitionValue_checked
                      ? 'power-on'
                      : 'power-off'
                      }`">
                      <div class="switch-body flex-mid">
                        <div v-if="settingData.recognitionValue_checked" class="mr-auto ml-14 mt-2">
                          ON
                        </div>
                        <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                      </div>
                    </label>
                  </div>
                </div>
                <span class="fc-4A4A4A fs-14 fw-700">Recognition Values</span>
              </div>
              <div :class="`setting-row ${settingData.recognitionValue_checked
                ? 'mt-24'
                : 'expand-setting'
                }`" :style="`margin-left: 7px; height: ${!settingData.recognitionValue_checked
      ? 0
      : uiSetting.recognitionValue_checked_row
      }px;`">
                <div ref="recognitionValue_checked_row">
                  <div v-if="popover.langRecognition == 'EN'">
                    <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                      class="flex-center flex-wrap" style="gap: 12px 0">
                      <div v-for="(value, index) in recognitionValue" :key="value.value + '_input'" class="relative">
                        <input class="recognition-tags input-growup" :style="$utils('fontStyle', value.label) + ' !important'
                          " type="text" :id="`input-growup-${index}`" v-model="value.label" @input="(event) => onInputRecognitionModel(event, index)
      " />
                        <span class="ml-12 fs-16 cursor-pointer icon-close" @click="removeRecognitionTag(value.value)"><i
                            class="el-icon-close" style="font-weight: 700"></i></span>
                        <span class="span-growup" :id="`span-growup-${index}`"></span>
                      </div>
                    </draggable>
                    <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                      <span @click="showRecognitionInput" v-if="!saveRecognitionInput"
                        class="recognition-tags flex-center cursor-pointer">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">New Value</span>
                      </span>
                      <input class="recognition-tags input" v-if="saveRecognitionInput" style="height: 18px"
                        v-model="saveRecognitionValue" ref="saveRecognitionInput"
                        @keyup.enter="handleInputRecognitionConfirm" @blur="handleInputRecognitionConfirm" />
                    </div>
                  </div>
                  <div v-else>
                    <draggable v-model="recognitionDataSetting" v-bind="dragOptions" @update="updateCradList"
                      class="flex-center flex-wrap" style="gap: 12px 0">
                      <div v-for="(value, index) in recognitionValue" :key="value.value + '_input'" class="relative">
                        <input class="recognition-tags input-growup" :style="$utils('fontStyle', value.labelTh) + ' !important'
                          " type="text" :id="`input-growup-${popover.langRecognition.toLowerCase()}-${index}`" v-model="value.names[popover.langRecognition.toLowerCase()]" @input="(event) => onInputRecognitionModel(event, index)
      " />
                        <span class="ml-12 fs-16 cursor-pointer icon-close" @click="removeRecognitionTag(value.value)"><i
                            class="el-icon-close" style="font-weight: 700"></i></span>
                        <span class="span-growup" :id="`span-growup-${popover.langRecognition.toLowerCase()}-${index}`"></span>
                        <div class="popup">
                          <div class="fs-10 fw-700">DEFAULT</div>
                          <div class="fs-12 opa-07">{{ value.label }}</div>
                        </div>
                      </div>
                    </draggable>
                    <div class="mt-12 flex-center">
                      <span class="
                          recognition-tags
                          flex-center
                          disable
                          cursor-default
                        ">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">New Value</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="line-style mt-24" />
              <div class="flex">
                <div>
                  <div ref="peer-feedbak" class="header-text mt-24">
                    Peer Feedback
                  </div>
                  <div class="description-text">
                    At the beginning of each month, each member will be able to
                    select up to 2 people to receive feedback from. When giving
                    feedback, reviewers can assign the following tags that
                    represent what the recipient "excels" at:
                  </div>
                </div>
                <el-popover placement="bottom-end" width="200" trigger="click" class="mt-24 ml-auto"
                  v-model="popover.visiblePeerFeedback" v-if="settingData.peerFeedbackInteractions_checked && multiLang"
                  popper-class="language-selector-popover">
                  <div class="language-selector-content">
                    <div class="language-selector-header">
                      <i class="el-icon-s-flag"></i>
                      <span>Select Language</span>
                    </div>
                    <div v-for="val in language" :key="val.code" 
                         class="language-option" 
                         :class="{ 'active': popover.langPeerFeedback === val.code.toUpperCase() }"
                         @click="setLanguage('peerFeedback', val.code.toUpperCase())">
                      <div class="language-flag">
                        <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                          {{ getLanguageEmoji(val.code) }}
                        </div>
                      </div>
                      <span class="language-text">{{ val.text }}</span>
                      <i v-if="popover.langPeerFeedback === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                    </div>
                  </div>
                  <div slot="reference" class="language-selector-button">
                    <div class="language-selector-content-btn">
                      <div class="language-flag-btn">
                        <div class="flag-icon-btn" :class="`flag-${getCurrentLanguageCode('peerFeedback').toLowerCase()}`">
                          {{ getLanguageEmoji(getCurrentLanguageCode('peerFeedback')) }}
                        </div>
                      </div>
                                            <span class="language-text-btn">{{ popover.langPeerFeedback }}</span>
                      <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': popover.visiblePeerFeedback }"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
              <div class="flex-center mt-24">
                <div class="switch mr-16">
                  <div class="can-toggle">
                    <input class="input" type="checkbox" id="peerFeedbackInteractions_checked"
                      v-model="settingData.peerFeedbackInteractions_checked" />
                    <label for="peerFeedbackInteractions_checked" :class="`${settingData.peerFeedbackInteractions_checked
                      ? 'power-on'
                      : 'power-off'
                      }`">
                      <div class="switch-body flex-mid">
                        <div v-if="settingData.peerFeedbackInteractions_checked" class="mr-auto ml-14 mt-2">
                          ON
                        </div>
                        <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                      </div>
                    </label>
                  </div>
                </div>
                <span class="fc-4A4A4A fs-14 fw-700">Peer Feedback Interactions</span>
              </div>
              <div :class="`setting-row ${settingData.peerFeedbackInteractions_checked
                ? 'mt-24'
                : 'expand-setting'
                }`" style="margin-left: 7px;">
                <div ref="peerFeedbackInteractions_checked_row">
                  <div v-if="popover.langPeerFeedback == 'EN'">
                    <div class="flex-center flex-wrap" style="gap: 12px 0">
                      <span v-for="values in peerFeedbackExcels" :key="values.key" class="peer-feedback-tags flex-center">
                        <span>{{ values.name }}</span>
                        <span class="ml-8 fs-14 cursor-pointer" @click="inspectPeerFeedbackTag(values)" title="Inspect attributes">
                          <i class="el-icon-info" style="font-weight: 700"></i>
                        </span>
                        <span class="ml-8 fs-16 cursor-pointer" @click="removePeerFeedbackTag(values.key)"><i
                            class="el-icon-close" style="font-weight: 700"></i></span>
                      </span>
                    </div>
                    <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                      <span @click="showPeerFeedbackInput" v-if="!savePeerFeedbackInput"
                        class="peer-feedback-tags flex-center cursor-pointer">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">New Skill</span>
                      </span>
                      <input class="peer-feedback-tags input" v-if="savePeerFeedbackInput" style="height: 18px"
                        v-model="savePeerFeedbackValue" ref="savePeerFeedbackInput"
                        @keyup.enter="handleInputPeerFeedbackConfirm" @blur="handleInputPeerFeedbackConfirm" />
                    </div>
                  </div>
                  <div v-else>
                    <div class="flex-wrap" style="gap: 12px 0px">
                      <div v-for="(value, index) in peerFeedbackExcels" :key="value.key + '_input'" class="relative">
                        
                        <input class="peer-feedback-tags input-growup" :style="`${$utils(
                          'fontStyle',
                          value.name_th
                        )} !important;'`" type="text" :id="`input-peer-growup-${popover.langPeerFeedback.toLowerCase()}-${index}`" v-model="value.names[popover.langPeerFeedback.toLowerCase()]" @input="(event) => onInputPeerFeedbackModel(event, index)
    " />
                        <span class="ml-8 fs-14 cursor-pointer icon-close" @click="inspectPeerFeedbackTag(value)" title="Inspect attributes">
                          <i class="el-icon-info" style="font-weight: 700"></i>
                        </span>
                        <span class="ml-8 fs-16 cursor-pointer icon-close" @click="removePeerFeedbackTag(value.key)"><i
                            class="el-icon-close" style="font-weight: 700"></i></span>
                        <span class="span-growup" :id="`span-peer-growup-${popover.langPeerFeedback.toLowerCase()}-${index}`"></span>
                        <div class="popup">
                          <div class="fs-10 fw-700">DEFAULT</div>
                          <div class="fs-12 opa-07">{{ value.name }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-12 flex-center">
                      <span class="
                          peer-feedback-tags
                          flex-center
                          disable
                          cursor-default
                        ">
                        <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                        <span class="">New Excel Tag</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="village">
            <span slot="label" class="title-bar">Happily Village</span>
            <!-- Happily Village Tab -->
            <el-form class="margin-subpages" @submit.native.prevent>
              <div style="margin-top: 32px;">
                <span class="sub-title">HAPPILY VILLAGE</span>
                <div class="line-style mt-24" />
                
                <div class="header-text mt-32">Village Access</div>
                <div class="description-text">
                  All members will have access to a Happily Village with
                  interactions that will promote wellness, learning, and
                  collaboration with a Running Track, University, Houses, and more!
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="happilyVillageAccess_checked"
                        v-model="settingData.happilyVillageAccess_checked" />
                      <label for="happilyVillageAccess_checked" :class="`${settingData.happilyVillageAccess_checked
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.happilyVillageAccess_checked" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Happily Village Access</span>
                </div>

                <div class="line-style mt-32" />
                <div class="header-text mt-32">Topic Creation Permissions</div>
                <div class="description-text">
                  Control who can initiate discussions in the Town Hall. When restricted, only company admins can create new topics, 
                  while all employees can still participate in existing discussions.
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="create_topics"
                        v-model="settingData.create_topics" />
                      <label for="create_topics" :class="`${settingData.create_topics
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.create_topics" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Allow Employee Topic Creation</span>
                </div>
                <div class="description-text mt-8" style="font-style: italic; color: #908D95;">
                  {{ settingData.create_topics ? 
                    'All employees can create new topics and start discussions.' : 
                    'Only company admins can create new topics. All employees can participate in discussions.' }}
                </div>

                <div class="line-style mt-32" />
                <div class="header-text mt-32">Town Hall Agent</div>
                <div class="description-text">
                  Enhance workplace discussions with an AI-powered conversation starter. The Town Hall Agent creates engaging topics 
                  and polls based on your chosen themes, fostering meaningful dialogue and employee engagement in your virtual town square.
                </div>
                <div class="flex-center mt-24">
                  <div class="switch mr-16">
                    <div class="can-toggle">
                      <input class="input" type="checkbox" id="townHallAgent_checked"
                        v-model="settingData.townHallAgent_checked" />
                      <label for="townHallAgent_checked" :class="`${settingData.townHallAgent_checked
                        ? 'power-on'
                        : 'power-off'
                        }`">
                        <div class="switch-body flex-mid">
                          <div v-if="settingData.townHallAgent_checked" class="mr-auto ml-14 mt-2">
                            ON
                          </div>
                          <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <span class="fc-4A4A4A fs-14 fw-700">Town Hall Agent</span>
                </div>

                <div :class="`setting-row ${settingData.townHallAgent_checked ? 'mt-24' : 'expand-setting'}`">
                  <div class="description-text mt-16" style="font-style: italic;">
                    Add conversation themes below to guide the Town Hall Agent in creating relevant and engaging topics for your team.
                  </div>
                  <div class="flex-center flex-wrap mt-16" style="gap: 12px 0">
                    <span v-for="theme in townHallThemes" :key="theme.key" class="peer-feedback-tags flex-center">
                      <span>{{ theme.name }}</span>
                      <span class="ml-12 fs-16 cursor-pointer" @click="removeTownHallTheme(theme.key)">
                        <i class="el-icon-close" style="font-weight: 700"></i>
                      </span>
                    </span>
                  </div>
                  <div class="mt-12 flex-center" style="flex-wrap: wrap; gap: 12px 0">
                    <span @click="showTownHallThemeInput" v-if="!saveTownHallThemeInput"
                      class="peer-feedback-tags flex-center cursor-pointer">
                      <span class="mr-12 fs-16"><i class="el-icon-plus" style="font-weight: 700"></i></span>
                      <span class="">Add Theme</span>
                    </span>
                    <input class="peer-feedback-tags input" v-if="saveTownHallThemeInput" style="height: 18px"
                      v-model="saveTownHallThemeValue" ref="saveTownHallThemeInput"
                      @keyup.enter="handleInputTownHallThemeConfirm" @blur="handleInputTownHallThemeConfirm" 
                      placeholder="e.g., Innovation, Work-Life Balance" />
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane name="emailNotifications">
            <span slot="label" class="title-bar">Email Notifications</span>
            <!-- Email Notifications Tab -->
            <el-form class="margin-subpages">
              <div id="emailNotifications">
                <span class="sub-title">EMAIL NOTIFICATIONS</span>
                <div class="line-style mt-24" />

                <!-- Reward redemption notifications -->
                <div class="mt-24" v-if="settingData.emailNotifications">
                  <div class="header-text">Reward Redemption</div>
                  <div class="description-text">
                    Managers receive email when their team member redeems a reward
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="managerRewardRedemption_checked"
                          v-model="settingData.emailNotifications.managerRewardRedemption" />
                        <label for="managerRewardRedemption_checked" :class="`${settingData.emailNotifications.managerRewardRedemption
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.emailNotifications.managerRewardRedemption" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Notify Manager When Direct Report Redeems a Reward</span>
                  </div>
                </div>

                <!-- Outstanding feedback notifications -->
                <div class="mt-24" v-if="settingData.emailNotifications">
                  <div class="header-text">Peer Feedback Truly Outstanding Rating</div>
                  <div class="description-text">
                    Managers receive email when their direct report gets a Truly Outstanding peer feedback rating
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="managerPeerFeedbackOutstanding_checked"
                          v-model="settingData.emailNotifications.managerPeerFeedbackOutstanding" />
                        <label for="managerPeerFeedbackOutstanding_checked" :class="`${settingData.emailNotifications.managerPeerFeedbackOutstanding
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.emailNotifications.managerPeerFeedbackOutstanding" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Notify Manager of Truly Outstanding Feeback Recipient</span>
                  </div>
                </div>

                <!-- Manager activity reports -->
                <div class="mt-24">
                  <div class="header-text">Manager Activity Reports</div>
                  <div class="description-text">
                    Managers receive monthly reports showing their management activity and performance
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="managerActivityReport_checked"
                          v-model="settingData.report_activity_manager" />
                        <label for="managerActivityReport_checked" :class="`${settingData.report_activity_manager
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.report_activity_manager" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Deliver Monthly Manager Activity Reports</span>
                  </div>
                </div>

                <!-- HR monthly reports -->
                <div class="mt-24">
                  <div class="header-text">HR Monthly Overview Reports</div>
                  <div class="description-text">
                    HR team receives comprehensive monthly reports with key insights and metrics
                  </div>
                  <div class="flex-center mt-18">
                    <div class="switch mr-16">
                      <div class="can-toggle">
                        <input class="input" type="checkbox" id="hrMonthlyReports_checked"
                          v-model="settingData.report_monthlyhr" />
                        <label for="hrMonthlyReports_checked" :class="`${settingData.report_monthlyhr
                          ? 'power-on'
                          : 'power-off'
                          }`">
                          <div class="switch-body flex-mid">
                            <div v-if="settingData.report_monthlyhr" class="mr-auto ml-14 mt-2">
                              ON
                            </div>
                            <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <span class="fc-4A4A4A fs-14 fw-700">Deliver HR Monthly Reports</span>
                  </div>
                </div>

              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- Modal Holiday Presets -->
    <el-dialog :visible.sync="showModal_holiday_presets" :before-close="closeModalHolidayPresets" width="1100px"  top="8vh" custom-class="holiday-preset-dialog">
            <div class="flex-center" style="background-color:#F8F8F8;">
              <div class="modal-1" style="width:640px; "> 
                <div  class="flex-column" style="margin-top: 40px;">
                    <div class="flex-center" style="justify-content: space-between;">
                    <div class="flex-column">
                      <span class="fs-20 fw-700 mb-8" style="color: #000;">
                        Holiday Presets
                      </span>
                      <div class="opa-06">
                        Manage when daily pulse questions should not be delivered
                      </div>

                    </div>
                
                    <el-button style="width:133.7px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;margin-right: 32px;padding: 0px;" @click="createPreset">
                      <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"/>
                        </svg>
                        <span>Create Preset</span>
                      </div>
                    </el-button>

                    </div>
                    <div class="fs-16 fw-700 pt-32 fc-323232" style="margin-top: 20px;">My Presets Library</div>
                    <div>
                    <el-input class="input-style mb-32 mt-12 " style="font-size: 15px; width: 260px !important" autosize
                      :placeholder="$t('global.Search')"  v-model="inputSearch_preset" clearable></el-input>
                    </div>
                    <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loading_preset">
                      <loading-even></loading-even>
                    </div>

                    <div v-else>
                      <!-- card -->
                      <div v-for="(item,index) in presetlist" :key="index" class="mb-8 cursor-pointer" :class="`${item.focus_preset?'preset-focus':'preset-library'}`" @click="ClickEditPresets(index)">
                        <div class="flex-center" style="justify-content: left;">
                      
                          <div class="flex-center" style="width: 396px;">
                            <div class="flex-center" :style="`justify-content: center;background:${item.focus_preset?'#EEE5FD':'#EDEDED'} 0% 0% no-repeat padding-box;border-radius: 12px;width: 52px;height: 52px;color:${item.focus_preset?'#6C30CC':'#000'}`">{{ item.total_assignments }}</div>
                            <div class="flex-column" style="margin-left: 16px;">
                              <span class="fs-15 fw-700 fc-2E2E2E" >{{ item.name }}</span>
                              <span class="fs-13 fc-2E2E2E mt-4" >{{gettextAssigned((item.teams?item.teams.length:0), (item.users?item.users.length:0))}}</span>
                            </div>
                          </div>
                          <div class="flex-center" style="justify-content: space-between;width:205px;">
                            
                            <div class="fs-12 fc-2E2E2E" >{{ item.total_assignments }} assignments total</div>
                            <div class="arrow-right">
                              <svg xmlns="http://www.w3.org/2000/svg" width="10.477" height="20" viewBox="0 0 10.477 20">
                                <path id="Path_40066" data-name="Path 40066" d="M102.335,54.335l-9.524,9.524a.476.476,0,1,1-.674-.674L101.324,54l-9.187-9.187a.476.476,0,0,1,.674-.674l9.524,9.524a.476.476,0,0,1,0,.674" transform="translate(-91.998 -43.998)"/>
                              </svg>
                            </div>

                          </div>


                        </div>
                        


                      </div>

                    </div>




                  </div>
        
                    




              
                </div>

                <div class="modal-2" style="width:460px;">

                  <div v-if="status_show_preset_forms" class="flex-center" style="justify-content: center;height: 100%;text-align: center;">
                    <div class="fs-16 fw-700" style="color: #000;opacity: 0.4;">Create a Holiday Preset to disable daily pulse questions on a person's day off</div>
                  </div>
                  <div v-else>
                    
                  
                    <div class="flex-column" style="margin-top: 40px;">
                      <div class="fs-20 fw-700" style="color: #000;">{{ title_preset }}</div>
                      <div class="fs-14 fw-700 pt-24">Preset Name</div>
                      <div v-if="presetForm_verify.name==true" class="validate-worming-data">
                        <el-input class="input-style mt-8"  style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>
                        <div class="validate-worming-data-text ">
                          Please enter a preset name
                        </div>
                      </div>
                      <div v-else>
                        <el-input class="input-style mt-8" style="font-size: 15px; width: 376px !important;" autosize
                        placeholder="Enter preset name"  v-model="presetForm.name"></el-input>

                      </div>
                      
                    </div>

                    <div class="fs-14 fw-700 pt-16 pb-16">Day Off in the Week</div>

                      <el-checkbox-group
                        v-model="presetForm.dayoff"
                        @change="handleCheckedDayChange"
                      >
                        <el-checkbox v-for="day in dayofweek" :key="day" :label="day" :value="day" class='flex-column fs-13 fw-700 mb-15' style="width: 100%;">
                          {{ day }}
                        </el-checkbox>
                      </el-checkbox-group>

                      <div class="flex-center pt-8">
                        <div class="switch mr-16">
                          <div class="can-toggle">
                            <input class="input" type="checkbox" id="company_holiday"
                              v-model="presetForm.company_holiday" />
                            <label for="company_holiday" :class="`${presetForm.company_holiday
                              ? 'power-on'
                              : 'power-off'
                              }`">
                              <div class="switch-body flex-mid">
                                <div v-if="presetForm.company_holiday" class="mr-auto ml-14 mt-2 fs-13">
                                  ON
                                </div>
                                <div v-else class="ml-auto mr-10 mt-2">OFF</div>
                                
                              </div>
                         
                            </label>
                          </div>
                        </div>
                        <span class="fc-4A4A4A fs-14">Also Apply Company Holidays</span>
                      </div>

                      <!-- Specific Days Off Section -->
                      <div class="fs-14 fw-700 pt-24 pb-8">Specific Days Off</div>
                      <div class="fs-13 fc-908D95 pb-12">Add individual dates when pulse questions should be paused</div>
                      <div v-if="presetForm.holiday_dates && presetForm.holiday_dates.length > 0" style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px;">
                        <div 
                          class="preset-date-tag" 
                          v-for="(item, index) in presetForm.holiday_dates" 
                          :key="'preset-date-' + index">
                          <i class="el-icon-date date-icon"></i>
                          <span>{{ item }}</span>
                          <i @click="removePresetHolidayDate(index)" class="el-icon-close"></i>
                        </div>
                      </div>
                      <div style="position: relative;">
                        <el-button style="width:160px;height:33px;background: #32C2D5;color: #FFFFFF;border: none;font-size: 14px;padding: 0px;" @click="showPresetDatepicker">
                          <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            <i class="el-icon-plus" style="font-size: 16px; font-weight: 700;"></i>
                            <span>Add Dates</span>
                          </div>
                        </el-button>
                        <el-date-picker 
                          :clearable="false" 
                          :editable="false" 
                          @change="confirmPresetHolidayDatepicker"
                          class="dialogInputDatepicker" 
                          ref="datepicker_preset_holiday" 
                          type="dates" 
                          v-model="presetForm.holiday_dates_val"
                          placement="bottom-start" 
                          style="position: absolute; top: 0; left: 0; opacity: 0; pointer-events: none;">
                        </el-date-picker>
                      </div>

                      <div class="flex-center mb-12" style="justify-content: space-between;">
                        <div class="fs-16 fw-700 pt-32">Assign to Teams</div>
                        <div class="fs-14 pt-32 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('team')"> + Add Teams</div>
                      </div>
                      <div v-for="team in presetForm.team" :key="team.id+'team'" class="mb-8">
                        <div class="flex-center" style="justify-content: left;padding: 16px 6px 16px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                          <div class="flex-center" style="width: 376px;">
                            <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ team.name }}</div>
                            <div class="fs-13 pl-10 fc-908D95">{{ team.membersteams }} members</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteTeam(team.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div class="flex-center mt-21 mb-12" style="justify-content: space-between;">
                        <div class="fs-16 fw-700 pt-16">Assigned Members</div>
                        <div class="fs-14 pt-16 fc-6C30CC pr-16 cursor-pointer" @click="openAddMemberTeam('member')"> + Add Member</div>
                      </div>
                      <div v-for="users in presetForm.users" :key="users.email+'members'" class="mb-8">
                        <div class="flex-center" style="justify-content: left;padding: 8px 6px 8px 12px;background: #F5EFFF 0% 0% no-repeat padding-box;">
                          <div class="flex-column" style="width: 376px;">
                            <div class="fs-16 fw-500 pl-16 fc-323232" style="color: #000;opacity: 1;">{{ users.firstname }} {{ users.lastname }}</div>
                            <div class="fs-13 pl-16 fw-400 fc-9D9D9D mt-2">{{ users.team_name }}</div>
                          </div>
                          <div class="pr-16 cursor-pointer" @click="deleteUser(users.email)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.707" height="16.707" viewBox="0 0 16.707 16.707">
                              <g id="Close" transform="translate(0.354 0.354)">
                                <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                                <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>



                    <div v-if="popup_preset.show" class="warning-popup-1">
                      <div class="body flex-center" style="width: 368px;justify-content: space-between;">
                        <div class="fs-500 fc-FFFFFF fs-14">
                          {{popup_preset.title}}
                        </div>
                        <div v-if="popup_preset.status=='update'"><el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color:#F44336;width:54px;height:32px;font:13px;" @click="deletePreset">{{popup_preset.button_left}}</el-button>
                        <el-button v-if="popup_preset.button_right" style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:92px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                        </div>
                        <div v-else>
                          <el-button style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #FFFFFF;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #6c30cc;width:62px;height:32px;font:13px;" @click="clearData">{{popup_preset.button_left}}</el-button>
                        <el-button  style="border: 1px solid var(--unnamed-color-ffffff);border: 1px solid #32C2D5;border-radius: 3px;color: #FFFFFF;font-size: 14px;padding: 0px;background-color: #32C2D5;width:104px;height:32px;font:13px" @click="savePreset">{{popup_preset.button_right}}</el-button>
                        </div>
                        
                      
                        
                      </div>
                    </div>
                    
                    

                 
                </div>



                
                



                    
              </div>
              

            </div>

    </el-dialog>

     <!-- Add Member and Team -->
     <el-dialog :visible.sync="addMemberTeam" :before-close="cancelselectedTeamandMember"  width="1120px" custom-class="add-member-team-dialog" top="3vh">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:360px;background: #F8F8F8 0% 0% no-repeat padding-box !important; height: 94vh; min-height: 600px; padding-left: 16px !important;">
            <div class="fs-20 fc-2D2E36 fw-700 pt-24 pb-16" style="padding-left: 8px;">{{addMemberTeamForm.type=='team'?selected_team.length:selected_user.length}} {{ addMemberTeamForm.title_left }}</div>

            <div v-if="addMemberTeamForm.type=='team'" style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="team in selected_team" :key="`${team.id}_select_team`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <img  style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0;">
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{team.name}}</div>
                    <div class="fs-12 fw-400 fc-9D9D9D">{{team.membersteams}} members</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteTeam(team.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16.707 16.707">
                    <g id="Close" transform="translate(0.354 0.354)">
                      <path id="Path_2" data-name="Path 2" d="M0,0,16,16" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                      <path id="Path_2_Copy" data-name="Path 2 Copy" d="M-10,0-26,16" transform="translate(26)" fill="none" stroke="#979797" stroke-miterlimit="10" stroke-width="1"/>
                    </g>
                  </svg>
                </div>

              </div>

              

              </div>
            </div>
            <div v-else style="padding-left: 8px; padding-right: 16px; max-height: calc(94vh - 120px); overflow-y: auto;">
              <div v-for="user in selected_user" :key="`${user.email}`" class="selected-team-item">
              <div class="flex-center" style="justify-content: space-between;">


                <div class="flex-center" style="justify-content: left; flex: 1; min-width: 0;">
                  <img v-if="user.profilepic_crop" :src="user.profilepic_crop" style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0;" @error="$event.target.style.display='none'">
                  <div v-else style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; color: #666; font-size: 12px; font-weight: 600;">
                    {{ getInitials(user.firstname, user.lastname) }}
                  </div>
                  <div style="min-width: 0; flex: 1;">
                    <div class="fs-14 fc-4A4A4A fw-600" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{user.firstname}} {{user.lastname}}</div>
                    <div class="fs-12 fc-908D95 fw-400" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{user.team_name}}</div>
                  </div>
                </div>


                <div class="cursor-pointer" style="padding: 4px;" @click="deleteUser(user.email)">
                  <img :src="$utils('icons', 'x-16x16px')" style="width: 14px;height: 14px;">
                </div>

              </div>

              

              </div>


            </div>
          </div>

          <div class="modal-2" style="width:760px;background: #FFFFFF 0% 0% no-repeat padding-box !important;overflow-y: hidden !important;overflow-x: hidden !important; height: 94vh; min-height: 600px;">
            
            <div class="flex-column" style="justify-content: space-between; padding: 24px 24px 24px 20px;">
              <div class="fs-24 fw-700" style="color: #2D2E36;">{{addMemberTeamForm.title}}</div>
              <div>
                <el-input v-model="searchmemberandteamandMember" style="width: 300px;" :placeholder="addMemberTeamForm.placeholder" class="w-100 mt-16"></el-input>
              </div>
              <div class="fs-14 fc-908D95 mt-12 mb-12">Results based on the search terms…</div>
              <div>

                <div v-if="addMemberTeamForm.type=='team'">


                  <div class="grid-selection-container">
                    <!-- All Teams Selection -->
                    <div class="all-teams-button" @click="toggleAllTeams">
                      <div class="flex-center" style="justify-content: center; width: 100%; height: 100%; align-items: center;">
                        <i :class="allTeamsSelected ? 'el-icon-check' : 'el-icon-plus'" style="font-size: 18px; margin-right: 8px; color: #32C2D5; font-weight: 700;"></i>
                        <div class="fs-16 fw-700" style="color: #32C2D5; margin-right: 8px;">{{ allTeamsSelected ? 'Deselect All Teams' : 'Select All Teams' }}</div>
                        <div class="fs-14" style="color: #666;">({{ addMemberTeamForm.team ? addMemberTeamForm.team.length : 0 }} teams)</div>
                      </div>
                    </div>
                    
                    <div v-for="(team,id) in addMemberTeamForm.team" :key="addMemberTeamForm.team[id].id"  :class="addMemberTeamForm.team[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'team')">
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;padding-left: 16px;">
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.team[id].name}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2;">{{addMemberTeamForm.team[id].users.length}} members</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="grid-selection-container">
                    <div v-for="(user,id) in addMemberTeamForm.user" :key="addMemberTeamForm.user[id].email"  :class="addMemberTeamForm.user[id].statusClick?'border-blue':''" class="selection-cell" @click="selectedTeamAndMember(id,'user')">
                    
                        <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                          <div style="width: 8px;height: 100%;background: #6C30CC 0% 0% no-repeat padding-box;border-radius: 3px 0px 0px 3px;opacity: 1;"></div>
                          <div class="flex-center" style="justify-content: left;width: 100%;height: 100%;">
                            <img v-if="addMemberTeamForm.user[id].profilepic_crop" :src="addMemberTeamForm.user[id].profilepic_crop" style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 10px;margin-left: 10px;" @error="$event.target.style.display='none'">
                            <div v-else style="width: 32px;height: 32px;border-radius: 50%;background: #D8D8D8 0% 0% no-repeat padding-box;margin-right: 10px;margin-left: 10px; display: flex; align-items: center; justify-content: center; color: #666; font-size: 14px; font-weight: 600;">
                              {{ getInitials(addMemberTeamForm.user[id].firstname, addMemberTeamForm.user[id].lastname) }}
                            </div>
                            <div class="flex-column" style="min-width: 0; flex: 1;">
                              <div class="fs-14 fc-4A4A4A fw-700" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.user[id].firstname}} {{addMemberTeamForm.user[id].lastname}}</div>
                              <div class="fs-12 fc-9D9D9D" style="line-height: 1.2; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{addMemberTeamForm.user[id].team_name}}</div>
                          </div>
                          </div>


                        </div>


                      
                      
                    
                    </div>
                  </div>



                </div>

             


              <div class="flex-center" style="justify-content: flex-end; margin-top: 20px;">
                <el-button type="primary" style="width: 122px;height: 40px;background: #D1D1D1 0% 0% no-repeat padding-box;
                  border: none; margin-right: 16px;" @click="cancelselectedTeamandMember">CANCEL</el-button>
                <el-button type="primary"style="width: 120px;height: 40px;background: #32C2D5 0% 0% no-repeat padding-box;
                  border: none;" @click="submitselectedTeamandMember">SUBMIT</el-button>
              </div>
                
              </div>


              
            </div>


    
                
          </div>
          

        </div>

      </el-dialog>

            <!-- Submit member or team -->

      <el-dialog
        :visible.sync="confirm_add_dialog"
        width="650px" center style="max-height: 600px;min-height: 300px;"
        :before-close="handleClose"
      >
      
        <div class="flex-column" style="height: 300px;max-height: 300px;">
          <div class="fs-16 fc-908D95 fw-700" style="margin-top: 50px;margin-left: 30px;">{{ `Some selected ${addMemberTeamForm.type=='member'?'members':'teams'} have existing preset assignments` }}</div>
       
            <div v-for='(text,index) in text_confirm' :key="`${index}_text`" style="margin-top: 20px;margin-left: 30px;overflow-y: scroll;max-height: 300px;">
              {{ text }}
            </div>
            <div style="margin-top: 20px;margin-left: 30px;">Proceeding will override their existing preset assignments. Would you like to continue?</div>
         
        </div>
        <template>
          <div class="flex-center" style="justify-content: right;padding-bottom: 30px;padding-right: 30px;">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" @click="confirm_Add">
              Confirm
            </el-button>
          </div>
        </template>
       
      </el-dialog>

      <!-- Peer Feedback Tag Attributes Modal -->
      <el-dialog :visible.sync="peerFeedbackAttributesModal" width="900px" top="8vh" :before-close="closePeerFeedbackAttributesModal">
        <div class="flex-column">
          <div class="flex-center mb-24" style="justify-content: space-between;">
            <div class="fs-20 fw-700" style="color: #2D2E36;">
              {{ isEditingNewTag ? 'Create New Skill Tag' : 'Inspect Skill Tag' }}: {{ currentPeerFeedbackTag.name }}
            </div>
            
            <!-- Language Selector for Attributes -->
            <div v-if="multiLang" class="attribute-language-selector">
              <el-popover placement="bottom-end" width="200" trigger="click"
                          v-model="attributeLanguagePopoverVisible"
                          popper-class="language-selector-popover">
                <div class="language-selector-content">
                  <div class="language-selector-header">
                    <i class="el-icon-s-flag"></i>
                    <span>Select Language</span>
                  </div>
                  <div v-for="val in language" :key="val.code" 
                       class="language-option" 
                       :class="{ 'active': currentAttributeLanguage === val.code.toUpperCase() }"
                       @click="setAttributeLanguage(val.code.toUpperCase())">
                    <div class="language-flag">
                      <div class="flag-icon" :class="`flag-${val.code.toLowerCase()}`">
                        {{ getLanguageEmoji(val.code) }}
                      </div>
                    </div>
                    <span class="language-text">{{ val.text }}</span>
                    <i v-if="currentAttributeLanguage === val.code.toUpperCase()" class="el-icon-check language-check"></i>
                  </div>
                </div>
                <div slot="reference" class="language-selector-button">
                  <div class="language-selector-content-btn">
                    <div class="language-flag-btn">
                      <div class="flag-icon-btn" :class="`flag-${currentAttributeLanguage.toLowerCase()}`">
                        {{ getLanguageEmoji(currentAttributeLanguage) }}
                      </div>
                    </div>
                    <span class="language-text-btn">{{ currentAttributeLanguage }}</span>
                    <i class="el-icon-arrow-down language-arrow" :class="{ 'rotated': attributeLanguagePopoverVisible }"></i>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>

          <div class="flex-center mb-16" style="justify-content: space-between;">
            <div class="fs-16 fw-700">Attributes ({{ (currentPeerFeedbackTag.attributes || []).length }}/6)</div>
            <div class="flex-center" style="gap: 12px;">
              <div v-if="multiLang && currentAttributeLanguage !== 'EN'" class="fs-12 fc-908D95">
                Editing {{ currentAttributeLanguage }} translations
              </div>
              
              <el-button 
                v-if="newTag && (currentPeerFeedbackTag.attributes || []).length < 6"
                type="primary" 
                size="mini" 
                :loading="generatingAttributes"
                @click="generateAttributesWithAI"
                class="ai-generate-btn">
                <i class="el-icon-magic-stick mr-4"></i>
                {{ generatingAttributes ? 'Generating...' : 'Generate with AI' }}
              </el-button>
            </div>
          </div>
          
          <div v-if="attributeValidationError" class="mb-16 fs-14" style="color: #F44336;">
            {{ attributeValidationError }}
          </div>

          <div class="attributes-container">
            <div v-for="(attribute, index) in currentPeerFeedbackTag.attributes || []" :key="index" class="attribute-item mb-12">
              <div class="flex-column">
                <div class="flex-center">
                  <div class="attribute-number">{{ index + 1 }}</div>
                
                  <el-input
                    v-if="isEditingNewTag || editingAttributeIndex === index"
                    :value="getAttributeEditValue(attribute, index)"
                    :placeholder="`Enter attribute name in ${currentAttributeLanguage}`"
                    class="attribute-input"
                    @blur="saveAttributeEdit(index)"
                    @keyup.enter.native="saveAttributeEdit(index)"
                    @input="updateAttributeName(index, $event)"
                  />
                  <div v-else class="attribute-name">
                    {{ getAttributeDisplayName(attribute) }}

                  
                  </div>
                  <div v-if="!currentPeerFeedbackTag.status_master">
                    <div class="ml-auto flex-center">
                      <span v-if="!isEditingNewTag && editingAttributeIndex !== index" 
                            class="ml-8 fs-14 cursor-pointer" 
                            @click="editAttribute(index)" 
                            title="Edit attribute">
                        <i class="el-icon-edit" style="color: #6C30CC;"></i>
                      </span>
                      <span v-if="isEditingNewTag || editingAttributeIndex === index" 
                            class="ml-8 fs-14 cursor-pointer" 
                            @click="removeAttribute(index)" 
                            title="Remove attribute">
                        <i class="el-icon-close" style="color: #F44336;"></i>
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Translation status indicator -->
                <div v-if="multiLang && currentAttributeLanguage === 'EN' && !isEditingNewTag && editingAttributeIndex !== index" 
                     class="translation-status mt-8">
                  <div class="flex-center" style="gap: 8px;">
                    <div v-for="lang in language" :key="lang.code" 
                         class="translation-indicator"
                         :class="{ 'completed': hasTranslation(attribute, lang.code), 'missing': !hasTranslation(attribute, lang.code) }"
                         :title="`${lang.text}: ${hasTranslation(attribute, lang.code) ? 'Translated' : 'Missing translation'}`">
                      <div class="flag-mini">{{ getLanguageEmoji(lang.code) }}</div>
                      <i :class="hasTranslation(attribute, lang.code) ? 'el-icon-check' : 'el-icon-warning'" 
                         class="status-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="(currentPeerFeedbackTag.attributes || []).length < 6 && !currentPeerFeedbackTag.status_master" class="add-attribute-container">
              <div v-if="!showAddAttributeInput" 
                   class="add-attribute-btn cursor-pointer" 
                   @click="showAddAttributeInputField">
                <i class="el-icon-plus mr-8"></i>
                Add Attribute
              </div>
              <div v-else class="flex-center">
                <el-input
                  v-model="newAttributeName"
                  placeholder="Enter attribute name"
                  class="attribute-input"
                  ref="newAttributeInput"
                  @blur="addAttribute"
                  @keyup.enter.native="addAttribute"
                />
                <span class="ml-8 fs-14 cursor-pointer" @click="cancelAddAttribute" title="Cancel">
                  <i class="el-icon-close" style="color: #F44336;"></i>
                </span>
              </div>
            </div>
          </div>

          <div v-if="!currentPeerFeedbackTag.status_master" class="flex-center mt-32" style="justify-content: right;">
            <el-button @click="closePeerFeedbackAttributesModal">Cancel</el-button>
            <el-button v-if="isEditingNewTag" type="primary" @click="saveNewPeerFeedbackTag" :disabled="!canSaveNewTag">
              Create Skill Tag
            </el-button>
            <el-button v-else type="primary" @click="savePeerFeedbackTagChanges">
              Save Changes
            </el-button>
          </div>
        </div>
      </el-dialog>

  </div>
</template>

<script>
import format from "date-fns/format";
import firebase from "firebase/app";
import "firebase/database";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    loadingEven: require("./even/loading").default,
  },

  name: "settings",
  watch: {
    settingData: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    recognitionValue: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    peerFeedbackExcels: {
      handler() {
        this.handlerHeightOfSetting();
      },
      deep: true,
    },
    async searchmemberandteamandMember() {
      //console.log("searchmemberandteam",this.searchmemberandteamandMember)
      await this.$store.dispatch("settings/searchmemberandteamandMember", {value:this.searchmemberandteamandMember,type:this.addMemberTeamForm.type})
      if(this.addMemberTeamForm.type=='team'){
        this.addMemberTeamForm.team=[]
        for(const key in this.memberInteam){
          const _team=_.find(this.selected_team,{name:this.memberInteam[key].name})
          if(_team){
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
      }
      else{
        this.addMemberTeamForm.user=[]
        for(const key in this.member){
           //console.log('this.member',this.member[key])
          const _member=_.find(this.selected_user,{email:this.member[key].email})
          if(_member){
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})

          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
      }
    },
    inputSearch_preset: {
      handler(newVal) {
        //console.log('newVal',newVal)
        this.$store.dispatch("settings/searchData_preset", newVal)
        //this.searchmemberandteam()
      },
      deep: true
    },

    presetForm: {
      handler(newVal) {
        this.checkedChanges_preset()
        
      },
      deep: true 
    },
    showAddAttributeInput: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            if (this.$refs.newAttributeInput) {
              this.$refs.newAttributeInput.focus();
            }
          });
        }
      }
    },
  },
  data() {
    return {
      activeTab: 'general',
      dynamicTags: [
        "Leadership",
        "Initiative",
        "Clarity",
        "Timely",
        "Creativity",
        "Teamwork",
      ],
      saveRecognitionInput: false,
      saveRecognitionValue: "#",
      savePeerFeedbackInput: false,
      savePeerFeedbackValue: "",
      recognitionOldValue: [],
      uiSetting: {
        medalsForLeaders_checked_row: 0,
        recognitionValue_checked_row: 0,
        peerFeedbackInteractions_checked_row: 0,
      },
      setingChanged: false,
      popover: {
        visibleMedal: false,
        langMedal: "EN",
        visibleRecognition: false,
        langRecognition: "EN",
        visiblePeerFeedback: false,
        langPeerFeedback: "EN",
      },
      recognitionDataSetting: [
        {
          label_th: "test1",
          label_en: "ทดสอบ1",
          id: "test1",
        },
        {
          label_th: "test2_test2",
          label_en: "ทดสอบ2_test2",
          id: "test2",
        },
        {
          label_th: "test3",
          label_en: "ทดสอบ3",
          id: "test3",
        },
      ],
      overdueMonths: [2, 3, 4, 5, 6],
      dayofweek:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
      showModal_holiday_presets: false,
      inputSearch_preset: '',
      status_show_preset_forms:true,
      title_preset:'',
      presetForm:{
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],      // Formatted date strings for display
        holiday_dates_val: [],  // Date objects for date picker binding
        company_holiday: true,
        users:[],
        teams:[],
      },
      presetForm_old:{
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        team:[],
        user:[],
      },
      popup_preset:{
        show:false,
        title:'',
        content:'',
        button_left:'',
        button_right:'',
      },
      presetForm_verify:{
        name:  false,
      },
      addMemberTeam:false,
      addMemberTeamForm:{
        title_left:'',
        type:'',
        title:'',
        description:'',
        team:[],
        user:[],
        selected:[],
        placeholder:''
      },
      selected_team:[],
      selected_user:[],
      searchmemberandteamandMember:'',
      confirm_add_dialog:false,
      text_confirm:[],
      status_edit_preset:false,
      index_focus:'',
      // townHallThemes: [
      //   { key: 'innovation', name: 'Innovation' },
      //   { key: 'work-life-balance', name: 'Work-Life Balance' },
      //   { key: 'team-building', name: 'Team Building' },
      //   { key: 'problem-solving', name: 'Problem Solving' },
      //   { key: 'communication', name: 'Communication' },
      //   { key: 'leadership', name: 'Leadership' },
      //   { key: 'creativity', name: 'Creativity' },
      //   { key: 'adaptability', name: 'Adaptability' },
      //   { key: 'empathy', name: 'Empathy' },
      //   { key: 'time-management', name: 'Time Management' },
      // ],
      saveTownHallThemeInput: false,
      saveTownHallThemeValue: '',
      peerFeedbackAttributesModal: false,
      isEditingNewTag: false,
      editingAttributeIndex: null,
      currentPeerFeedbackTag: {
        name: '',
        attributes: [],
        key: '',
      },
      newAttributeName: '',
      attributeValidationError: '',
      showAddAttributeInput: false,
      currentAttributeLanguage: 'EN',
      attributeLanguagePopoverVisible: false,
      generatingAttributes: false,
      newTag:false,
    };
  },

  created() {
    // this.$store.dispatch("settings/getoldExcelsByCompany");
    this.$store.dispatch("settings/checkEngOnly", this.user);
    this.$store.dispatch("settings/getDataSetting", this.user);
    // this.$store.dispatch("settings/getExcelsByCompany");
    this.$store.dispatch("settings/getoldDataSetting", this.user);
    this.$store.dispatch("member/getMember", this.user);
    this.$store.dispatch("settings/getmemberInteam", this.user);
    

    //this.oldRecognitionValue = [...this.recognitionValue];
  },
  mounted() {
    this.handlerHeightOfSetting();
    this.handlerHeightOfSetting(1000);
    this.goto();
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    settingData() {
      return this.$store.getters["settings/setting"];
    },
    countAll() {
      return this.$store.getters["member/countAll"];
    },
    peerFeedbackExcels() {
      return this.$store.getters["settings/excels"];
    },
    hashTagId() {
      return this.$store.getters["settings/hashTagId"];
    },
    settingOldDataMock() {
      return this.$store.getters["settings/settingOldDataMock"];
    },
    oldRecognitionValue() {
      return this.$store.getters["settings/oldRecognitionValue"];
    },
    recognitionValue: {
      get() {
        return this.$store.getters["settings/recognitionValue"];
      },
      set(newValue) {
        this.$store.commit("settings/setRecognitionValue", newValue);
      },
    },
    multiLang() {
      return this.$store.getters["settings/multiLang"];
    },
    oldExcels() {
      return this.$store.getters["settings/oldExcels"];
    },
    language(){
      return this.$store.getters["settings/language"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    member(){
      return this.$store.getters["settings/member"];
    },
    memberInteam(){
      return this.$store.getters["settings/memberinteam"];
    },    
    presetlist(){
      return this.$store.getters["settings/presetlist"];
    },
    presetlistAll(){
      return this.$store.getters["settings/presetlistAll"];
    },
    loading_preset(){
      return this.$store.getters["settings/loading_preset"];
    },
    townHallThemes() {
      return this.$store.getters["settings/townHallThemes"];
    },
    canSaveNewTag() {
      if (!this.currentPeerFeedbackTag.name.trim() || 
          !this.currentPeerFeedbackTag.attributes || 
          this.currentPeerFeedbackTag.attributes.length !== 6) {
        return false;
      }
     
      //console.log('this.currentPeerFeedbackTag.attributes',this.currentPeerFeedbackTag.attributes)
      // Check that all attributes have at least the default (EN) name
      return this.currentPeerFeedbackTag.attributes.every(attr => attr.name && attr.name.trim());
    },
    excels_detail(){
      return this.$store.getters["settings/excels_detail"];
    },
    allTeamsSelected() {
      if (!this.addMemberTeamForm.team || this.addMemberTeamForm.team.length === 0) return false;
      return this.addMemberTeamForm.team.every(team => team.statusClick);
    },
  },
  methods: {
    toggleDemoMode() {
      this.$store.commit('demomode/changeBlurMode');
    },
    getInitials(firstName, lastName) {
      if (!firstName && !lastName) return '?';
      const first = firstName ? firstName.charAt(0).toUpperCase() : '';
      const last = lastName ? lastName.charAt(0).toUpperCase() : '';
      return first + last || '?';
    },
    getTotalTeamMembers() {
      if (!this.addMemberTeamForm.team) return 0;
      return this.addMemberTeamForm.team.reduce((total, team) => {
        return total + (team.users ? team.users.length : 0);
      }, 0);
    },
    toggleAllTeams() {
      
      if (!this.addMemberTeamForm.team) return;
      
      const allSelected = this.allTeamsSelected;
      
      // Toggle all teams
      this.addMemberTeamForm.team.forEach(team => {
        team.statusClick = !allSelected;
      });
      
      // Update the selected teams array
      if (!allSelected) {
        // Select all teams
        this.selected_team = this.addMemberTeamForm.team.map(team => ({
          id: team.id,
          name: team.name,
          membersteams: team.users ? team.users.length : 0,
          newteam:true
        }));
        
      } else {
        // Deselect all teams
        this.selected_team = [];
      }
    },
    updateCradList(event) {
      this.recognitionValue = this.arrayMovePosition(
        this.recognitionValue,
        event.oldIndex,
        event.newIndex
      );
    },
    arrayMovePosition(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    goto() {
      const hash = this.$router.currentRoute.hash.split("#")[1];
      var element = this.$refs[hash];
      if (element) {
        const top = element.offsetTop;
        window.scrollTo(0, top + 230);
      }
      if (element) {
        this.$refs[hash].scrollTop = 0 + 230;
      }
    },
    handlerHeightOfSetting(time) {
      let wait = 50;
      if (time) {
        wait = time;
      }
      setTimeout(() => {
        this.checkedChanges();
        this.matchHeight();
      }, wait);
    },
    showRecognitionInput() {
      this.saveRecognitionInput = true;
      this.$nextTick((_) => {
        this.$refs.saveRecognitionInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    showPeerFeedbackInput() {
      //console.log('showPeerFeedbackInput')
      this.savePeerFeedbackInput = true;
      this.$nextTick((_) => {
        this.$refs.savePeerFeedbackInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    async handleInputRecognitionConfirm() {
      let _recognitionValue = this.recognitionValue;
      await this.$store.dispatch("settings/newIdhashtag");
      const saveRecognitionValue = this.saveRecognitionValue;
      if (saveRecognitionValue !== "#") {
        _recognitionValue.push({
          value: this.hashTagId,
          label: saveRecognitionValue,
          labelTh: "#",
        });
        this.recognitionValue = _recognitionValue;
      }
      this.saveRecognitionInput = false;
      this.saveRecognitionValue = "#";

      this.handlerHeightOfSetting(150);
    },
    async handleInputPeerFeedbackConfirm() {
     // console.log('handleInputPeerFeedbackConfirm')
      const key=await firebase.database().ref(`excels_company/${this.user.company}`).push().key;
      //console.log('key',key)
      this.currentPeerFeedbackTag.new_excel=true
      this.currentPeerFeedbackTag.key=key
      // Instead of creating the tag immediately, open the attributes modal
      if (this.savePeerFeedbackValue !== "") {
        this.currentPeerFeedbackTag = {
          name: this.savePeerFeedbackValue,
          attributes: [],
          key: '',
        };
        this.isEditingNewTag = true;
        this.newTag=true
        this.peerFeedbackAttributesModal = true;
        this.savePeerFeedbackInput = false;
        this.savePeerFeedbackValue = "";
      }
    },
    removeRecognitionTag(id) {
      if (id) {
        this.recognitionValue = this.recognitionValue.filter((obj) => {
          return obj.value !== id;
        });
      }
      this.handlerHeightOfSetting(150);
    },
    removePeerFeedbackTag(id) {
      if (id) {
        let peerFeedbackExcels = {};
        peerFeedbackExcels = this.peerFeedbackExcels.filter((obj) => {
          return obj.key !== id;
        });
        this.$store.commit("settings/setExcels", peerFeedbackExcels);
      }
      this.handlerHeightOfSetting(150);
    },
    saveChanges() {
      if (
        !this.settingData.starttime ||
        !this.settingData.report_dailyboss_time ||
        !this.settingData.report_weeklyboss_time ||
        !this.settingData.Creativity.replace(/ /g, "") ||
        !this.settingData.Initiative.replace(/ /g, "") ||
        !this.settingData.Kindness.replace(/ /g, "") ||
        !this.settingData.Strength.replace(/ /g, "") ||
        !this.settingData.Charisma.replace(/ /g, "") ||
        !this.settingData.Intelligence.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Valid Data required.",
          type: "error",
        });
      } else {
        var messageLoading = this.$message({
          type: "warning",
          message: "Saving changes...",
          duration: "9999000",
        });
        this.$store
          .dispatch("settings/saveChanges", {
            id: this.id,
            form: this.settingData,
            recognitionValue: this.recognitionValue,
            company: this.user.company,
            countMembers: this.countAll,
            thisvue: this,
            messageLoading: messageLoading,
            excels: this.peerFeedbackExcels,
          })
          .then(() => {
            setTimeout(() => {
              this.$store.dispatch("settings/getDataSetting", this.user);
              this.$store.dispatch("settings/getoldDataSetting", this.user);
            }, 1000);
          });
      }
    },
    showDatepickerHoliday() {
      this.$refs.datepicker_holiday.focus();
    },
    showPresetDatepicker() {
      this.$refs.datepicker_preset_holiday.focus();
    },
    confirmPresetHolidayDatepicker() {
      let tag = [];
      let val = [];
      if (
        this.presetForm.holiday_dates_val &&
        this.presetForm.holiday_dates_val.length > 0
      ) {
        let data = _.orderBy(this.presetForm.holiday_dates_val);
        for (const i in data) {
          tag.push(format(data[i], "dddd, MMMM D, YYYY"));
          val.push(data[i]);
        }
      }
      this.presetForm.holiday_dates = tag;
      this.presetForm.holiday_dates_val = val;
    },
    removePresetHolidayDate(index) {
      this.presetForm.holiday_dates.splice(index, 1);
      this.presetForm.holiday_dates_val.splice(index, 1);
    },
    confirmHolidayDatepicker() {
      let tag = [];
      let val = [];
      if (
        this.settingData["holiday_val"] &&
        this.settingData["holiday_val"].length > 0
      ) {
        let data = _.orderBy(this.settingData["holiday_val"]);
        for (const i in data) {
          tag.push(format(data[i], "dddd, MMMM D, YYYY"));
          val.push(data[i]);
        }
      }
      this.settingData["holiday_tag"] = tag;
      this.settingData["holiday_val"] = val;
    },
    removeTag(index) {
      this.settingData["holiday_tag"].splice(index, 1);
      this.settingData["holiday_val"].splice(index, 1);
    },
    getPaddingStyle(data) {
      if (data && data.length > 0) {
        return "12px";
      } else {
        return "20px";
      }
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion;
      location.reload(true);
      this.goto();
    },
    checkedChanges() {
      const settingData = _.isArray(this.settingOldDataMock) ? true : 
        _.isEqual(this.settingData, this.settingOldDataMock);
      const excels = _.isEqual(this.peerFeedbackExcels, this.oldExcels);
      const recognitionValue = _.isEqual(
        this.recognitionValue,
        this.oldRecognitionValue
      );
      if (!settingData || !recognitionValue || !excels) {
        this.setingChanged = true;
      } else {
        this.setingChanged = false;
      }
    },
    undoSaveSetting() {
      if (this.settingOldDataMock.performance_review) {
        this.pendingAfterChange(_.get(this.settingOldDataMock, "performance_review.pending"));
      }
      this.$store.commit("settings/setDataSetting", this.settingOldDataMock);
      this.$store.commit("settings/setExcels", this.oldExcels);
      this.recognitionValue = [...this.oldRecognitionValue];
      this.$store.dispatch("settings/getDataSetting", this.user);
      this.$store.dispatch("settings/getoldDataSetting", this.user);
      this.$store.dispatch("settings/getExcelsByCompany");
      this.$store.dispatch("settings/getoldExcelsByCompany");
      this.checkedChanges();
    },
    matchHeight() {
      if (this.$refs.medalsForLeaders_checked_row) {
        this.uiSetting.medalsForLeaders_checked_row =
          this.$refs.medalsForLeaders_checked_row.clientHeight;
      }
      if (this.$refs.recognitionValue_checked_row) {
        setTimeout(() => {
          if (this.$refs.recognitionValue_checked_row.clientHeight > 73) {
            this.uiSetting.recognitionValue_checked_row =
              this.$refs.recognitionValue_checked_row.clientHeight;
          } else {
            this.uiSetting.recognitionValue_checked_row = 74;
          }
        }, 100);
      }
      if (this.$refs.peerFeedbackInteractions_checked_row) {
        setTimeout(() => {
          this.uiSetting.peerFeedbackInteractions_checked_row =
            this.$refs.peerFeedbackInteractions_checked_row.clientHeight;
        }, 120);
      }
    },
    setLanguage(value, lang) {
      switch (value) {
        case "medals":
          this.popover.visibleMedal = false;
          this.popover.langMedal = lang;
          break;
        case "recognition":
          this.updateAllContentRecognition();
          this.popover.visibleRecognition = false;
          this.popover.langRecognition = lang;
          break;
        case "peerFeedback":
          this.updateAllContentPeerFeedback();
          this.popover.visiblePeerFeedback = false;
          this.popover.langPeerFeedback = lang;
          break;
      }
      this.handlerHeightOfSetting();
    },
    onInputRecognition(event, index) {
      const labelTh = event.target.innerText;
      this.recognitionValue[index].labelTh = labelTh;
    },
    onRemoveRecognition(index) {
      if (
        this.recognitionValue.length > 1 &&
        this.recognitionValue[index].labelTh.length === 0
      ) {
        this.updateAllContentRecognition();
      }
    },
    updateAllContentRecognition() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.labelTh && el) {
          el.innerText = c.labelTh;
        }
      });
    },
    onInputPeerFeedback(event, index) {
      const name_th = event.target.innerText;
      this.peerFeedbackExcels[index].name_th = name_th;
    },
    onRemovePeerFeedback(index) {
      if (
        this.peerFeedbackExcels.length > 1 &&
        this.peerFeedbackExcels[index].name_th.length === 0
      ) {
        this.updateAllContentPeerFeedback();
      }
    },
    updateAllContentPeerFeedback() {
      this.peerFeedbackExcels.forEach((c, index) => {
        const el = document.getElementById(`peerFeedbackExcels-${index}`);
        if (c.name_th && el) {
          el.innerText = c.name_th;
        }
      });
    },
    widthOfBox(text) {
      if (text) {
        if (text.length > 5 && text.length < 80) {
          return "";
        }
      }
      return "display: inline-block;";
    },
    onInputRecognitionModel(event, index) {
      const el = document.getElementById(`input-growup-${index}`);
      const span = document.getElementById(`span-growup-${index}`);
      el.addEventListener("input", function (event) {
        span.innerHTML = this.value.replace(/\s/g, "&nbsp;");
        this.style.width = span.offsetWidth + "px";
      });
    },
    onInputPeerFeedbackModel(event, index) {
      const el = document.getElementById(`input-peer-growup-${this.popover.langPeerFeedback.toLowerCase()}-${index}`);
      const span = document.getElementById(`span-peer-growup-${this.popover.langPeerFeedback.toLowerCase()}-${index}`);
      el.addEventListener("input", function (event) {
        span.innerHTML = this.value.replace(/\s/g, "&nbsp;");
        this.style.width = span.offsetWidth + "px";
      });
    },
    pendingAfterChange(min) {
      this.overdueMonths = _.filter([2, 3, 4, 5, 6], (value) => value > min);
      
      if (min < this.overdueMonths[0]) {
        this.settingData.performance_review.overdue = this.overdueMonths[0];
      }
      if(this.settingData.performance_review.pending!==1){
        this.settingData.performance_review.reset_completed_monthly=false
      }
    },




    createPreset(){
     // console.log('createPreset')
      this.selected_team=[]
      this.selected_user=[]
      this.status_edit_preset=false
      this.title_preset='Create Preset'
      this.status_show_preset_forms = false
      this.createPreset_status = true
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      
    },
    closeModalHolidayPresets() {
      this.showModal_holiday_presets = false;
    },
    handleCheckedDayChange(value) {
      this.presetForm.dayoff=value
    },
    openAddMemberTeam(type){
      this.addMemberTeamForm.team=[]
      this.addMemberTeamForm.user=[]
      this.addMemberTeam = true
      if(type=='member'){
        this.addMemberTeamForm.type='member'
        this.addMemberTeamForm.title_left='members selected'
        this.addMemberTeamForm.title=`Add members to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.placeholder='Search member name'

        for(const key in this.member){

          const _user=_.find(this.selected_user,function(item){return item.email==key})
          if(_user){ 
            this.addMemberTeamForm.user.push({key:key,statusClick:true,...this.member[key]})
          }else{
            this.addMemberTeamForm.user.push({key:key,statusClick:false,...this.member[key]})
          }
          
        }
        //console.log('addMemberTeamForm',this.addMemberTeamForm)
       
      }else{
        // console.log('add team',this.memberInteamAll)
        this.addMemberTeamForm.type='team'
        this.addMemberTeamForm.title=`Add teams to your ${this.presetForm.name} preset`
        this.addMemberTeamForm.title_left='teams selected'
        this.addMemberTeamForm.placeholder='Search team name'
        //console.log("key",this.selected_team)
        for(const key in this.memberInteam){
          
          const _team=_.find(this.selected_team,function(item){return item.id==key})
          if(_team){ 
            this.addMemberTeamForm.team.push({key:key,statusClick:true,...this.memberInteam[key]})
          }else{
            this.addMemberTeamForm.team.push({key:key,statusClick:false,...this.memberInteam[key]})
          }
          
        }
        

      }
      //console.log('addMemberTeamForm',this.addMemberTeamForm)
    },
    cancelselectedTeamandMember(){
      //console.log('cancelselectedTeamandMember',this.addMemberTeamForm.type)
      if(this.addMemberTeamForm.type=='team'){
        this.selected_team=this.presetForm&&this.presetForm.team?this.presetForm.team:[]
      }else{
        this.selected_user=this.presetForm&&this.presetForm.users?this.presetForm.users:[]
      }
     this.searchmemberandteamandMember=''
      this.addMemberTeam = false
   
    },
    submitselectedTeamandMember(){
      this.checkTeamAndMember()
      this.checkedChanges_preset()
    },
    async deleteUser(email){
      this.presetForm.users= _.filter(this.presetForm.users,(obj)=>{return obj.email!==email})
      this.selected_user=_.filter(this.selected_user,(obj)=>{return obj.email!==email})
      for(const key in this.addMemberTeamForm.user){
        if(email==this.addMemberTeamForm.user[key].email){
          this.addMemberTeamForm.user[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()
      
    },
    deleteTeam(team){
      //console.log('deleteTeam', team)
      this.presetForm.team= _.filter(this.presetForm.team,(obj)=>{return obj.id!==team})
      this.selected_team=_.filter(this.selected_team,(obj)=>{return obj.id!==team})
      
      for(const key in this.addMemberTeamForm.team){
        if(team==this.addMemberTeamForm.team[key].id){
          this.addMemberTeamForm.team[key].statusClick=false
        }
      }
      this.checkedChanges_preset()
      this.$forceUpdate()
    },
    checkedChanges_preset() {
      
      const check_preset=_.isEqual(this.presetForm,this.presetForm_old)
      if(!check_preset){
        if(this.createPreset_status){
          this.popup_preset={
          show:true,
          title:'Create new preset',
          content:'',
          status:'create',
          button_left:'Clear',
          button_right:'Save Preset',
          }

        }else {
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'Save Changes',
          }

        }
        
      }else{
        if(this.status_edit_preset){
          this.popup_preset={
          show:true,
          title:'Update your preset',
          content:'',
          status:'update',
          button_left:'Delete',
          button_right:'',
          }
        }else{
          // console.log('no changes')
        this.popup_preset={
            show:false,
            title:'',
            content:'',
            button_left:'',
            button_right:'',
            }

        }
      
      }
    },
    selectedTeamAndMember(id,type){

      if(type=='team'){
      this.addMemberTeamForm.team[id].statusClick=!this.addMemberTeamForm.team[id].statusClick
      const _find_team=this.selected_team.filter((item)=>{return item.id===this.addMemberTeamForm.team[id].id})
      if(_find_team.length==0){
        this.selected_team.push({membersteams:this.addMemberTeamForm.team[id].users?this.addMemberTeamForm.team[id].users.length:0,name:this.addMemberTeamForm.team[id].name,id:this.addMemberTeamForm.team[id].id,newteam:true})
      }else{
        this.selected_team=this.selected_team.filter((item)=>{return item.id!==this.addMemberTeamForm.team[id].id})
      }
      // this.selected_team=this.addMemberTeamForm.team[id]
      }else{       

        this.addMemberTeamForm.user[id].statusClick=!this.addMemberTeamForm.user[id].statusClick
        const _find_user=this.selected_user.filter((item)=>{return item.email===this.addMemberTeamForm.user[id].email})
        if(_find_user.length==0){
          this.selected_user.push({email:this.addMemberTeamForm.user[id].email,firstname  :this.addMemberTeamForm.user[id].firstname,lastname:this.addMemberTeamForm.user[id].lastname,team_name:this.addMemberTeamForm.user[id].team_name,profilepic_crop:this.addMemberTeamForm.user[id]&&this.addMemberTeamForm.user[id].profilepic_crop?this.addMemberTeamForm.user[id].profilepic_crop:'',newuser:true})
        }else{
          this.selected_user=this.selected_user.filter((item)=>{return item.email!==this.addMemberTeamForm.user[id].email})
        }
      }


      this.$forceUpdate()
    },
    async savePreset(){
     // console.log('savePreset')
      //this.verifyPreset()
      // if(this.presetForm_verify.name==true||this.presetForm_verify.goals==true||this.presetForm_verify.culture==true||this.presetForm_verify.next_review==true){
      //   return
      // }else{
        this.$store.dispatch('settings/updateAndCreatePreset',{preset:this.presetForm,duplicate:this.duplicateTeamandMamger})
        this.status_duplicate=false
        this.clearData()

      //}
      
    },
    clearData(){
      this.createPreset_status = false
      this.presetForm={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.presetForm_old={
        preset_id:'',
        name: '',
        dayoff: [],
        holiday_dates: [],
        holiday_dates_val: [],
        company_holiday: true,
        users:[],
        teams:[],
      }
      this.index_focus=''
      this.status_edit_preset=false
      this.status_show_preset_forms=true
      this.status_edit_preset=false
    },
    async deletePreset(){
      //console.log('deletePreset')
      this.$store.dispatch('settings/deletePreset',{preset_id:this.presetForm.preset_id})
      this.clearData()
    },
    checkTeamAndMember(){
      //console.log('checkTeamAndMember')
      this.text_confirm=[]
  
      //console.log('checkTeamAndMember',this.presetlistAll)
      const _presetlistAll=_.cloneDeep(this.presetlistAll)
      
      let _presetlistChange=_.cloneDeep(this.presetlistAll)
      if(this.status_duplicate==true){
        _presetlistChange=this.duplicateTeamandMamger
      }
      
      if(this.addMemberTeamForm.type=='team'){
        for(const key in _presetlistAll){
          //console.log('key',key)
          const teams=[]
          _presetlistChange[key].teams=[]
          if(_presetlistAll[key].teams){
              for(const team of _presetlistAll[key].teams){
              //console.log('team',team)
              //console.log('this.selected_team',this.selected_team)
              const _find_team=this.selected_team.filter((item)=>{return item.id===team})
              if(_find_team.length>0){
               // console.log('_find_team',_find_team)
                if(_find_team[0].newteam){
                  const text=`• Team "${_find_team[0].name}" is currently assigned to "${_presetlistAll[key].name}" preset`
                  this.text_confirm.push(text)
                  _presetlistChange[key].status_duplicate_team=true 
                  this.status_duplicate=true
                }
              }else{
                teams.push(team)
              }

            }
            if(teams.length>0){
              _presetlistChange[key].teams=teams
            }

          }
          
        }
      
        this.duplicateTeamandMamger=_presetlistChange
        this.confirm_add_dialog=true
      }else{
        for(const key in _presetlistAll){
          
          const users=[]
          _presetlistChange[key].users=[]
          if(_presetlistAll[key].users){
            for(const user of _presetlistAll[key].users){
            const _find_user=this.selected_user.filter((item)=>{return item.email===user})

            if(_find_user.length>0){
              if(_find_user[0].newuser){
                const text=`• Member "${_find_user[0].firstname} ${_find_user[0].lastname}" is currently assigned to "${_presetlistAll[key].name}" preset`
                this.text_confirm.push(text)
                _presetlistChange[key].status_duplicate_user=true
                this.status_duplicate=true
              }
            }else{
              _presetlistChange[key].users.push(user)

            }

            }
          }
        }
       
        this.duplicateTeamandMamger=_presetlistChange
        this.confirm_add_dialog=true
      }
      if(this.text_confirm==''){
        this.confirm_Add()
      }

    },
    handleClose(){
      this.confirm_add_dialog = false
    },
    confirm_Add(){

      if(this.addMemberTeamForm.type=='team'){
        this.presetForm.team=this.selected_team
      }else{
        this.presetForm.users=this.selected_user
      }
      this.addMemberTeam = false
      this.searchmemberandteamandMember=''
      this.confirm_add_dialog = false
      this.checkedChanges_preset()
    },
    gettextAssigned(team,member){
      if(team>0&&member==0){
        if(team==1){return 'Assigned to 1 team'}
        return `Assigned to ${team} teams`
      }else if(team==0&&member>0){
        if(member==1){return 'Assigned to 1 member'}
        return `Assigned to ${member} members`
      }else{
        if(team==1&&member==1){return 'Assigned to 1 team and 1 member'}
        return `Assigned to ${team} teams and ${member} members`
      }
    },
    ClickEditPresets(item){
     // console.log('ClickEditPresets',this.presetlist[item])
      const _presetlist=_.cloneDeep(this.presetlist[item])
      this.title_preset='Edit Preset'
      if(this.index_focus!==''){
        this.presetlist[this.index_focus].focus_preset = false
      }
      const holiday_day=[]
      if(_presetlist.holiday_day){
        for(const key in _presetlist.holiday_day){
          if(_presetlist.holiday_day[key]){
            holiday_day.push(key)
          }
        }
      }
      // Load specific holiday dates
      const holiday_dates = []
      const holiday_dates_val = []
      if (_presetlist.holiday_dates && _presetlist.holiday_dates.length > 0) {
        for (const dateStr of _presetlist.holiday_dates) {
          const dateParts = dateStr.split("-")
          const dateObj = new Date(`${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`)
          holiday_dates.push(format(dateObj, "dddd, MMMM D, YYYY"))
          holiday_dates_val.push(dateObj)
        }
      }
      this.status_edit_preset=true
      this.presetlist[item].focus_preset = true
      this.status_show_preset_forms = false
      this.presetForm.preset_id = _presetlist.id
      this.presetForm.name = _presetlist.name || ''
      this.presetForm.dayoff =holiday_day || []
      this.presetForm.holiday_dates = holiday_dates
      this.presetForm.holiday_dates_val = holiday_dates_val
      this.presetForm.company_holiday = _presetlist.company_holiday || false
      // this.presetForm.goals = _presetlist.goals || ''
      // this.presetForm.culture = _presetlist.culture || ''
      // this.presetForm.next_review =_presetlist.next_review || ''
      this.presetForm.team = _presetlist.team || []
      this.presetForm.users =_presetlist.data_users || []
      this.presetForm.team =_presetlist.data_team || []
      this.selected_team=_.cloneDeep(this.presetForm.team)
      this.selected_user=_.cloneDeep(this.presetForm.users)
      this.presetForm_old = _.cloneDeep(this.presetForm)
      this.index_focus=item
  
    },
    removeTownHallTheme(key) {
      const townHallThemes = this.townHallThemes.filter(theme => theme.key !== key);
      this.$store.commit('settings/setTownHallThemes', townHallThemes);

      const settingData = this.$store.getters["settings/setting"];
      settingData.townhall_themes = townHallThemes;
      this.$store.commit('settings/setDataSetting', settingData);

      this.handlerHeightOfSetting(150);
    },
    showTownHallThemeInput() {
      this.saveTownHallThemeInput = true;
      this.$nextTick((_) => {
        this.$refs.saveTownHallThemeInput.focus();
      });
      this.handlerHeightOfSetting(150);
    },
    handleInputTownHallThemeConfirm() {
      const saveTownHallThemeValue = this.saveTownHallThemeValue.trim();
      if (saveTownHallThemeValue !== "") {
        this.townHallThemes.push({ key: saveTownHallThemeValue.toLowerCase(), name: saveTownHallThemeValue });
        this.saveTownHallThemeValue = '';
        this.saveTownHallThemeInput = false;
        this.handlerHeightOfSetting(150);
      }
    },
    inspectPeerFeedbackTag(value) {
      //console.log('inspectPeerFeedbackTag',value)
      const excels_detail=_.cloneDeep(this.excels_detail[value.key]|| [])
      //console.log('excels_detail',excels_detail)
      //console.log('inspectPeerFeedbackTag')
      // Ensure the tag has the attributes structure
      if (!value.attributes) {
        value.attributes = [];
      }


      this.currentPeerFeedbackTag = {
        ...value,
        attributes: excels_detail
      };
      //console.log('this.currentPeerFeedbackTag',this.currentPeerFeedbackTag)
      this.isEditingNewTag = false;
      this.peerFeedbackAttributesModal = true;

      this.attributeValidationError = '';
    },
    editAttribute(index) {
      this.editingAttributeIndex = index;
    },
    saveAttributeEdit(index) {
      //console.log('saveAttributeEdit')
      this.editingAttributeIndex = null;
      this.attributeValidationError = '';
      if (!this.currentPeerFeedbackTag.attributes[index][`text_${this.currentAttributeLanguage.toLowerCase()}`].trim()) {
        this.attributeValidationError = 'Attribute name cannot be empty';
        this.currentPeerFeedbackTag.attributes[index][`text_${this.currentAttributeLanguage.toLowerCase()}`] = '';
      }
    },
    removeAttribute(index) {
      console.log('removeAttribute',index)
      
      this.currentPeerFeedbackTag.attributes.splice(index, 1);

      this.attributeValidationError = '';
    },
    addAttribute() {
      if (!this.newAttributeName.trim()) {
        this.attributeValidationError = 'Attribute name cannot be empty';
        return;
      }
      
      if (this.currentPeerFeedbackTag.attributes.length >= 6) {
        this.attributeValidationError = 'Maximum 6 attributes allowed';
        return;
      }
      
      // Create attribute with multi-language support
      let newAttribute = {
       text_en: this.newAttributeName.trim()
      };
      
      // If multi-language is enabled, initialize the names object
      if (this.multiLang) {
        newAttribute = {};
        // Create translations for all available languages
        for (const lang of this.language) {
          if (lang.code.toUpperCase() === 'EN') {
            newAttribute[`text_${lang.code.toLowerCase()}`] = this.newAttributeName.trim();
            //newAttribute.names[lang.code.toLowerCase()] = this.newAttributeName.trim();
          } else {
            newAttribute[`text_${lang.code.toLowerCase()}`] = '';
          }
        }
      }
      
      this.currentPeerFeedbackTag.attributes.push(newAttribute);
      this.newAttributeName = '';
      this.showAddAttributeInput = false;
      this.attributeValidationError = '';
    },
    cancelAddAttribute() {
      this.showAddAttributeInput = false;
      this.newAttributeName = '';
      this.attributeValidationError = '';
    },
    async saveNewPeerFeedbackTag() {
     // console.log('saveNewPeerFeedbackTag')
      if (!this.currentPeerFeedbackTag.name.trim()) {
        this.attributeValidationError = 'Skill tag name cannot be empty';
        return;
      }
      
      if (this.currentPeerFeedbackTag.attributes.length !== 6) {
        this.attributeValidationError = 'Exactly 6 attributes are required for a new skill tag';
        return;
      }
      
      if (!this.currentPeerFeedbackTag.attributes.every(attr => attr.name && attr.name.trim())) {
        this.attributeValidationError = 'All attributes must have names';
        return;
      }

      let peerFeedbackExcels = this.peerFeedbackExcels;
      let language = {};
      for (const i in this.language) {
        if (!language[this.language[i].code]) {
          language[this.language[i].code] = this.currentPeerFeedbackTag.name;
        }
      }
      const _language = _.clone(language);
      let newid = firebase.database().ref(`/excels_company/${this.user.company}`).push().key;
      
      const newTag = {
        name: this.currentPeerFeedbackTag.name,
        name_th: this.currentPeerFeedbackTag.name,
        names: _language,
        attributes: this.currentPeerFeedbackTag.attributes,
        status: "Y",
        updated: format(new Date(), "YYYY-MM-DD HH:mm"),
        createdate: format(new Date(), "YYYY-MM-DD HH:mm"),
        key: newid,
      };
      
      peerFeedbackExcels.push(newTag);
      this.$store.commit("settings/setExcels", peerFeedbackExcels);
      this.closePeerFeedbackAttributesModal();
      this.handlerHeightOfSetting(150);
    },
    savePeerFeedbackTagChanges() {
      //console.log('savePeerFeedbackTagChanges')
      // const peerFeedbackExcels = this.peerFeedbackExcels.map(tag =>
      //   tag.key === this.currentPeerFeedbackTag.key ? { 
      //     ...tag, 
      //     attributes: [...this.currentPeerFeedbackTag.attributes],
      //     updated: format(new Date(), "YYYY-MM-DD HH:mm"),
      //   } : tag
      // );
      for(const key in this.currentPeerFeedbackTag.attributes){
        // console.log('key',key)
        // console.log('this.currentPeerFeedbackTag.attributes[key]',this.currentPeerFeedbackTag.attributes[key])
        for (const lang of this.language) {
        // console.log('lang',lang)
        const error=this.validateAttributeName(this.currentPeerFeedbackTag.attributes[key][`text_${lang.code.toLowerCase()}`],lang.code)
        if(error){
          this.attributeValidationError=error
          return
        }
        }

      }
     //console.log('this.currentPeerFeedbackTag',this.currentPeerFeedbackTag)
      this.$store.dispatch('settings/savePeerFeedbackTagChanges',this.currentPeerFeedbackTag)
      this.closePeerFeedbackAttributesModal();
      //this.handlerHeightOfSetting(150);
    },
    closePeerFeedbackAttributesModal() {
      this.peerFeedbackAttributesModal = false;
      this.isEditingNewTag = false;
      this.editingAttributeIndex = null;
      this.showAddAttributeInput = false;
      this.newAttributeName = '';
      this.attributeValidationError = '';
      this.currentAttributeLanguage = 'EN';
      this.attributeLanguagePopoverVisible = false;
      this.generatingAttributes = false;
      this.currentPeerFeedbackTag = {
        name: '',
        attributes: [],
        key: '',
      };
    },
    showAddAttributeInputField() {
      this.showAddAttributeInput = true;
    },
    getLanguageEmoji(code) {
      const emojiMap = {
        'en': '🇺🇸',
        'th': '🇹🇭',
        'es': '🇪🇸',
        'fr': '🇫🇷',
        'de': '🇩🇪',
        'it': '🇮🇹',
        'pt': '🇵🇹',
        'ru': '🇷🇺',
        'ja': '🇯🇵',
        'ko': '🇰🇷',
        'zh': '🇨🇳',
        'ar': '🇸🇦',
        'hi': '🇮🇳',
        'nl': '🇳🇱',
        'sv': '🇸🇪',
        'no': '🇳🇴',
        'da': '🇩🇰',
        'fi': '🇫🇮',
        'pl': '🇵🇱',
        'tr': '🇹🇷'
      };
      return emojiMap[code.toLowerCase()] || '🌐';
    },
    getCurrentLanguageCode(type) {
      switch (type) {
        case 'recognition':
          return this.popover.langRecognition.toLowerCase();
        case 'peerFeedback':
          return this.popover.langPeerFeedback.toLowerCase();
        default:
          return 'en';
      }
    },
    setAttributeLanguage(lang) {
      this.currentAttributeLanguage = lang;
      this.attributeLanguagePopoverVisible = false;
    },
    getAttributeDisplayName(attribute) {
        // console.log('getAttributeDisplayName')
        // console.log('attribute',attribute)
        // console.log('this.currentAttributeLanguage',this.currentAttributeLanguage)
      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   return attribute.name || attribute[langKey] || '';
      // }

      return attribute[langKey]|| `(${this.currentAttributeLanguage} translation missing)`;
    },
    getAttributeEditValue(attribute, index) {
        // console.log('getAttributeEditValue')
        // console.log('attribute',attribute)
        // console.log('index====',index)
      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   return attribute.name || attribute[langKey] || '';
      // }
      
      return attribute[langKey] || '';
    },
    updateAttributeName(index, value) {
        // console.log('updateAttributeName')
        // console.log('value',value)
        // console.log('index',index)
      const attribute = this.currentPeerFeedbackTag.attributes[index];
      // console.log('attribute',attribute)
      
      const langKey = `text_${this.currentAttributeLanguage.toLowerCase()}`;
      
      // if (!this.multiLang || this.currentAttributeLanguage === 'EN') {
      //   // For English or when multi-language is disabled, update the main name field
      //  // this.$set(attribute, 'name', value);
      //   this.$set(attribute, langKey, value);
      // } else {
      //   // For other languages, update the specific language field
      //   this.$set(attribute, langKey, value);
      // }
      this.$set(attribute, langKey, value);
      // Force reactivity update
      this.$forceUpdate();
    },
    hasTranslation(attribute, langCode) {
      // console.log('hasTranslation')
      // console.log('attribute',attribute)
      // console.log('langCode',langCode)
      if (langCode.toUpperCase() === 'EN') {
        return attribute[`text_${langCode.toLowerCase()}`] && attribute[`text_${langCode.toLowerCase()}`].trim() !== '';
      }
      return attribute[`text_${langCode.toLowerCase()}`] && 
             attribute[`text_${langCode.toLowerCase()}`].trim() !== '';
    },
    async generateAttributesWithAI() {
      // console.log('generateAttributesWithAI')
      if (!this.currentPeerFeedbackTag.name.trim()) {
        this.attributeValidationError = 'Please enter a skill tag name first';
        return;
      }
      this.isEditingNewTag=false
      this.generatingAttributes = true;
      this.attributeValidationError = '';

      try {
        // Simulate AI generation - replace with actual AI API call
        const skillName = this.currentPeerFeedbackTag.name.trim();
        const generatedAttributesResult = await this.callAIAttributeGeneration(skillName);
        //console.log('generatedAttributesResult',generatedAttributesResult)
        
        // Ensure the result is an array
        let generatedAttributes = [];
        if (Array.isArray(generatedAttributesResult)) {
          generatedAttributes = generatedAttributesResult;
        } else if (generatedAttributesResult && typeof generatedAttributesResult === 'object') {
          // If it's an object, try to extract array from common property names
          generatedAttributes = generatedAttributesResult.attributes || 
                              generatedAttributesResult.data || 
                              generatedAttributesResult.items || 
                              Object.values(generatedAttributesResult);
        } else if (typeof generatedAttributesResult === 'string') {
          // If it's a string, try to parse it or split it
          try {
            const parsed = JSON.parse(generatedAttributesResult);
            generatedAttributes = Array.isArray(parsed) ? parsed : [generatedAttributesResult];
          } catch (e) {
            generatedAttributes = [generatedAttributesResult];
          }
        }
        
        // Final check to ensure it's an array
        if (!Array.isArray(generatedAttributes)) {
          console.warn('Generated attributes is not an array, creating empty array');
          generatedAttributes = [];
        }
        
        //console.log('generatedAttributes (processed)',generatedAttributes)
        
        // Calculate how many attributes we can add (max 6 total)
        const currentCount = (this.currentPeerFeedbackTag.attributes || []).length;
       // console.log('currentCount',currentCount)
        const availableSlots = 6 - currentCount;
        //console.log('availableSlots',availableSlots)
        const attributesToAdd = generatedAttributes.slice(0, availableSlots);
        //console.log('attributesToAdd',attributesToAdd)
        // Add the generated attributes
        for (const attributeName of attributesToAdd) {
          //console.log('attributeName',attributeName)
          const newAttribute = {
            //text_en: attributeName['en'].trim()
          };
          
          // If multi-language is enabled, initialize the names object
          if (this.multiLang) {
            newAttribute = {};
            for (const lang of this.language) {
              newAttribute[`text_${lang.code.toLowerCase()}`] = {};
              if (lang.code.toUpperCase() === 'EN') {
                newAttribute[`text_${lang.code.toLowerCase()}`] = attributeName['en'].trim();
              } else {
                newAttribute[`text_${lang.code.toLowerCase()}`] = attributeName[lang.code.toLowerCase()].trim();
              }
            }
          }
          
          this.currentPeerFeedbackTag.attributes.push(newAttribute);
          this.newTag=false
        }

        // Show success message
        this.$message({
          type: 'success',
          message: `Generated ${attributesToAdd.length} attributes for "${skillName}"`,
          duration: 3000
        });

      } catch (error) {
        console.error('Error generating attributes:', error);
        this.attributeValidationError = 'Failed to generate attributes. Please try again.';
        
        this.$message({
          type: 'error',
          message: 'Failed to generate attributes. Please try again.',
          duration: 3000
        });
      } finally {
        this.generatingAttributes = false;
      }
    },
    async callAIAttributeGeneration(skillName) {

      let languages='['
      for(const lang of this.language){
       // console.log('lang',lang)
        languages+=`"${lang.code.toLowerCase()}"`
        if(lang.code.toLowerCase()!==this.language[this.language.length-1].code.toLowerCase()){
          languages+=','
        }
      }
      languages+=']'
      //console.log('languages',languages)
      const value={
        skill:skillName,
        languages:languages
      }
      const result=await this.$store.dispatch('settings/callAIAttributeGeneration',value)
      //console.log('result',result)
      // This is a mock implementation - replace with actual AI API call
      return result
    },
    validateAttributeName(name,lang) {
      
      if (!name.trim()) {
        return `Attribute ${lang.toUpperCase()} cannot be empty`;
      }
      return '';
    }
  }
}
</script>
<style scoped>
.btnAddSettings {
  width: 172px;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
}

.div-page-content {
  flex: 1;
}

.inputLabelStyle {
  width: 138px;
  padding-top: 6px;
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
  text-align: right;
}

.inputReportStyle {
  font-size: 18px;
  width: 250px !important;
  margin-left: 12px;
}

.inputReportStyle.red>>>input.el-input__inner {
  border-color: #f44336;
}

.inputMedalStyle {
  font-size: 12px;
  width: 90px;
}

.popup {
  display: none;
  position: absolute;
  min-width: 120px;
  border-radius: 4px;
  padding: 10px 12px;
  background: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  transition: 0.2s;
}

.input-medal {
  font-size: 12px;
  font-weight: 700;
  color: #454545;
  width: 68px;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #c7c7c7;
  transition: 0.2s;
}

.input-medal:focus-visible,
.input-medal:focus {
  outline: 0;
  border: 1px solid #6c30cc;
}

.input-medal:hover~.popup,
.input-medal:focus~.popup {
  display: block;
}

.recognition-tags:hover~.popup,
.recognition-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.peer-feedback-tags:hover~.popup,
.peer-feedback-tags:focus~.popup {
  display: block;
  color: #000;
  background: #fff;
  z-index: 999;
}

.imgMedal {
  display: block;
  margin: auto;
  width: 72px;
  height: 101.89px;
}

.HolidayTagStyle {
  color: #484848;
  border-width: 1px;
  border-color: #747474;
  background-color: #f7f7f7;
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 12px;
  color: #747474;
}

.HolidayTagStyle.el-tag {
  padding: 0px 12px;
}

.el-tag .el-icon-close,
.el-tag .el-icon-close:hover {
  color: #747474;
  background: transparent;
}

.el-input.is-disabled>>>.el-input__inner {
  background-color: #f2f2f2;
  border-color: #c7c7c7;
  color: #747474 !important;
}

#formReport .el-input>>>.el-input__inner {
  color: #3b3b3b;
  font-weight: 400;
  height: 52px;
}

#formReport .el-input--prefix>>>.el-input__icon {
  padding-left: 6px;
}

#formReport .el-input--prefix>>>.el-input__inner {
  padding-left: 140px;
}

#formMedal .el-input>>>.el-input__inner {
  text-align: center;
  color: #454545;
  border-color: #c7c7c7;
  font-weight: 700;
  height: 32px;
  text-overflow: ellipsis;
}

#formMedal .el-input>>>.el-input__inner:focus {
  outline: none;
  border-color: #797979;
}

.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}

.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.dialogInputDatepicker>>>input.el-input__inner {
  opacity: 0;
  cursor: default;
  padding: 0px;
  height: 33px;
  width: 159px;
}

.dialogInputDatepicker>>>span.el-input__prefix {
  display: none;
}

.btn_AddHolidayStyle {
  position: absolute;
  cursor: pointer;
  width: 159px;
  height: 33px;
}

.txt-header {
  width: 170px;
  color: #3b3b3b;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  text-align: left;
}

.txt-description {
  color: #4a4a4a;
  font-size: 14px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  background: #00acc1;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-top: 10px;
}

.button-new-tag:hover {
  background: #00acc1;
  color: #ffffff;
}

.input-new-tag {
  width: 98px;
  vertical-align: bottom;
  margin-top: 10px;
}

.el-tag-peer-feedback {
  background: #00acc1;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-right: 10px;
  margin-top: 10px;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 6px;
}

.description-text {
  font-size: 14px;
  color: #4a4a4a;
  width: 740px;
  margin-right: auto;
}
.modal-1{
    overflow-y: scroll;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;
    max-height: 1200px;
}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  padding-left: 42px;
  padding-right: 42px;
  min-height: 847px;
  max-height: 1200px;
  position: relative;
}
.btn-preset{
  width: 200px;
  height: 33px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  span span{
    padding: 0px;
  }
}

.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin: 0 2px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 3px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  font-size: 12px;
  font-weight: 500;
  color: #4A4A4A;
}

.key + .key {
  margin-left: 2px;
}

/* Peer Feedback Attributes Modal Styles */
.attributes-container {
  max-height: 400px;
  overflow-y: auto;
}

.attribute-item {
  padding: 12px;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  background: #F8F8F8;
}

.attribute-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #6C30CC;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}

.attribute-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #2D2E36;
  padding: 8px 0;
}

.attribute-input {
  flex: 1;
  margin-right: 12px;
}

.add-attribute-container {
  margin-top: 16px;
}

.add-attribute-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: 2px dashed #C7C7C7;
  border-radius: 4px;
  color: #6C30CC;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.add-attribute-btn:hover {
  border-color: #6C30CC;
  background: rgba(108, 48, 204, 0.05);
}

.peer-feedback-tags .el-icon-info {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.peer-feedback-tags:hover .el-icon-info {
  opacity: 1;
}
</style>
<style lang="scss" scoped>
input {
  outline: 0;
}

.input-growup {
  width: 100px;
  outline: 0;
  padding: 4px 28px 4px 12px !important;
  min-height: 19px;

  &:focus {
    border-color: #6c30cc;
  }
}

.span-growup {
  position: absolute;
  left: -9999px;
  display: inline-block;
  min-width: 6em;
}

.setting-row {
  transition: 0.2s;
}

.expand-setting {
  height: 0px;
  overflow: hidden;
}

.recognition-tags {
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #00acc1;
  color: #00acc1;
  border-radius: 30px;
  padding: 5px 12px 3px;
  margin-right: 6px;
  transition: 0.2s;

  &:hover {
    background-color: #00abc118;
  }
}

.recognition-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #00acc1;
}

.recognition-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  color: #000;

  &:hover {
    background-color: #fff;
  }
}

.peer-feedback-tags {
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #00acc1;
  background-color: #00acc1;
  color: #fff;
  border-radius: 4px;
  margin-right: 6px;
  padding: 5px 12px 3px 12px;
  transition: 0.2s;

  &:hover {
    background-color: #02a2b8;
  }
}

.peer-feedback-tags~.icon-close {
  right: 18px;
  top: 7px;
  position: absolute;
  color: #fff;
}

.peer-feedback-tags.disable {
  opacity: 0.2;
  border: 2px solid #000;
  background-color: #000;
  color: #fff;

  &:hover {
    background-color: #000;
  }
}

/* Language Selector Styles */
.language-selector-button {
  display: inline-flex;
  align-items: center;
  height: 36px;
  min-width: 80px;
  padding: 0 12px;
  border: 1px solid #E4E4E4;
  border-radius: 6px;
  background: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.language-selector-button:hover {
  border-color: #6C30CC;
  box-shadow: 0 2px 8px rgba(108, 48, 204, 0.15);
}

.language-selector-content-btn {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.language-flag-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.language-flag-btn .flag-icon-btn {
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-text-btn {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #2D2E36;
}

.language-arrow {
  font-size: 12px;
  color: #908D95;
  transition: transform 0.2s ease;
}

.language-selector-button:hover .language-arrow {
  color: #6C30CC;
}

.language-arrow.rotated {
  transform: rotate(180deg);
}

.language-selector-content {
  padding: 8px 0;
}

.language-selector-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #908D95;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #F0F0F0;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.language-option:hover {
  background: #F8F6FF;
}

.language-option.active {
  background: #F0EBFF;
  color: #6C30CC;
}

.language-option.active .language-text {
  font-weight: 600;
}

.language-flag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  overflow: hidden;
  background: #F5F5F5;
}

.language-flag .flag-icon {
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.language-text {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #2D2E36;
}

.language-check {
  font-size: 16px;
  color: #6C30CC;
  font-weight: 700;
}

/* Translation Status Indicators */
.translation-status {
  margin-left: 36px;
}

.translation-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  transition: all 0.2s ease;
}

.translation-indicator.completed {
  background: #E8F5E8;
  color: #4CAF50;
}

.translation-indicator.missing {
  background: #FFF3E0;
  color: #FF9800;
}

.translation-indicator .flag-mini {
  font-size: 12px;
  line-height: 1;
}

.translation-indicator .status-icon {
  font-size: 10px;
}

/* AI Generate Button */
.ai-generate-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 8px 12px !important;
  height: auto !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3) !important;
}

.ai-generate-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4) !important;
}

.ai-generate-btn:active {
  transform: translateY(0) !important;
}

.ai-generate-btn .el-icon-magic-stick {
  font-size: 14px;
}

/* Preset Date Tags - Custom styling for specific dates */
.preset-date-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #F5EFFF;
  border: 1px solid #D4C4F0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #4A4A4A;
  transition: all 0.2s ease;
}

.preset-date-tag:hover {
  background: #EEE5FD;
  border-color: #6C30CC;
}

.preset-date-tag .el-icon-close {
  color: #908D95;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.preset-date-tag:hover .el-icon-close {
  color: #6C30CC;
}

.preset-date-tag .date-icon {
  color: #6C30CC;
  font-size: 14px;
}

/* Grid Selection Container */
.grid-selection-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  max-height: calc(94vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  width: 100%;
}

/* Custom scrollbar for grid container */
.grid-selection-container::-webkit-scrollbar {
  width: 6px;
}

.grid-selection-container::-webkit-scrollbar-track {
  background: #F0F0F0;
  border-radius: 3px;
}

.grid-selection-container::-webkit-scrollbar-thumb {
  background: #C7C7C7;
  border-radius: 3px;
}

.grid-selection-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.selection-cell {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  height: 52px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}

.selection-cell:hover {
  border-color: #6C30CC;
  box-shadow: 0 2px 4px rgba(108, 48, 204, 0.1);
}

.selection-cell.border-blue {
  border-color: #6C30CC;
  border-width: 2px;
  background: #F8F6FF;
}

/* Selected team/user items in left panel */
.selected-team-item {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #E4E4E4;
}

.selected-team-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

/* All Teams Button */
.all-teams-button {
  grid-column: 1 / -1; /* Span across both columns */
  background: #F8F9FA;
  border: 2px dashed #32C2D5;
  border-radius: 6px;
  height: 56px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 12px;
}

.all-teams-button:hover {
  background: #E8F4F8;
  border-style: solid;
  box-shadow: 0 2px 8px rgba(50, 194, 213, 0.15);
  transform: translateY(-1px);
}

.style-bar {
  width: 100%;
  margin-top: 0;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #FFFFFF;
}

.title-bar {
  font-size: 15px;
  color: inherit;
  font-weight: inherit;
}
</style>
<style lang="scss">
.holiday-preset-dialog {
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
}

.add-member-team-dialog {
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog {
    margin-top: 3vh !important;
  }
}

/* Purple checkbox styling for Holiday Preset modal */
.holiday-preset-dialog .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #6C30CC !important;
  border-color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__inner:hover {
  border-color: #6C30CC !important;
}

.holiday-preset-dialog .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #6C30CC !important;
}

#settingContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  padding: 0 20px;
  font-size: 16px;
  color: #4A4A4A;
  font-weight: 400;
  position: relative;
}

#settingContainer .el-tabs__item.is-active {
  color: #6C30CC;
  font-weight: 700;
}

#settingContainer .el-tabs__item:hover {
  color: #6C30CC;
}

#settingContainer .el-tabs__active-bar {
  height: 3px;
  background-color: #6C30CC;
  bottom: 0;
}

#settingContainer .el-tabs__header {
  margin: 0;
  border-bottom: 1px solid #E4E4E4;
}

#settingContainer .el-tabs__nav-wrap::after {
  display: none;
}

#settingContainer .el-tabs__nav {
  padding: 0 20px;
}

#divMedal span.el-switch__core {
  height: 14px;
  width: 27px !important;
  border: none;
}

#divMedal span.el-switch__core::after {
  background: #ffffff;
  width: 10px;
  height: 10px;
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
}

#divMedal .el-switch.is-checked .el-switch__core::after {
  margin-left: -12px;
  margin-top: 1px;
}

#tagPeer i.el-tag__close.el-icon-close {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

// .el-tabs__nav-wrap {
//   &::after {
//     display: none;
//   }
// }

// .el-tabs__header {
//   margin: 0;
//   border-bottom: 1px solid #E4E4E4;
// }

// .el-tabs__item {
//   height: 52px;
//   line-height: 52px;
//   padding: 0 20px;
//   font-size: 16px;
//   color: #4A4A4A;
//   font-weight: 400;

//   &.is-active {
//     color: #6C30CC;
//     font-weight: 700;
//   }

//   &:hover {
//     color: #6C30CC;
//   }
// }

// .el-tabs__active-bar {
//   height: 3px;
//   background-color: #6C30CC;
// }

// .el-tabs__nav {
//   padding: 0 20px;
// }

/* Global Language Selector Popover Styles */
.language-selector-popover {
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #E4E4E4 !important;
}

.language-selector-popover .el-popover__title {
  display: none !important;
}

.language-selector-popover .popper__arrow {
  border-bottom-color: #FFFFFF !important;
}

.language-selector-popover .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}
</style>
